const dpaTurnkey = [
  {
    "item no.": "1",
    "tasks": "PROJECT MANAGEMENT",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "1.1",
    "tasks": "Project planning, construction management on site and construction meeting and reporting.",
    "mitrex": true,
    "client": true
  },
  {
    "item no.": "1.2",
    "tasks": "Progress reporting.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "1.3",
    "tasks": "General Coordination of the project with Client.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "1.4",
    "tasks": "Health and safety management.",
    "mitrex": true,
    "client": true
  },
  {
    "item no.": "1.5",
    "tasks": "Coordination between Employer, subcontractors, and authorities (including hydro company).",
    "mitrex": true,
    "client": true
  },
  {
    "item no.": "1.6",
    "tasks": "Construction site insurance.",
    "mitrex": true,
    "client": true
  },
  {
    "item no.": "1.7",
    "tasks": "Construction signage (transportation, warnings).",
    "mitrex": true,
    "client": true
  },
  {
    "item no.": "2",
    "tasks": "DOCUMENTATIONS",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "2.1",
    "tasks": "Safety Induction Documentation.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "2.2",
    "tasks": "Method Statement & Risk Assessment for Installation.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "2.3",
    "tasks": "HSE Compliance Documentation.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "2.4",
    "tasks": "Hydro Commissioning Documentation.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "2.5",
    "tasks": "Markup of IFC drawings for any changes to be incorporated into the as-built drawings.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "3",
    "tasks": "PERMITS",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "3.1",
    "tasks": "Relation and permitting with municipality regarding building permits.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.2",
    "tasks": "Relation and permitting with ESA.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "3.3",
    "tasks": "Relation and permitting with hydro company.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "3.4",
    "tasks": "Hydro Permitting: Engineering, drawings, and documentation.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "3.5",
    "tasks": "Hydro Permitting: Information gathering and coordination.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.6",
    "tasks": "All local and federal government building permit charges.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.7",
    "tasks": "Negotiations with hydro to turn off the high-tension lines and obtain any necessary permits. Assumption of responsibility for the delays occurred because of this omission to do so and payment of any fees relating to that.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4",
    "tasks": "DESIGN",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.1",
    "tasks": "DC Works Engineering",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.1.1",
    "tasks": "General and detailed wiring layout design.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.2",
    "tasks": "Detailed execution drawings design (including earthing layout).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.3",
    "tasks": "Communication design (protocols and wires).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.4",
    "tasks": "Definition of metering devices dedicated to control system and located at Point of Interconnection.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.5",
    "tasks": "Panel and string connection scheme.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.6",
    "tasks": "Transformers definition.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.7",
    "tasks": "AC/DC cables definition wiring with calculation note.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.2",
    "tasks": "AC Works Engineering",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.2.1",
    "tasks": "Basic Design.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.2.2",
    "tasks": "Detailed execution drawings design.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.2.3",
    "tasks": "Equipment and protection definition (included AC Junction Box).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": 4.3,
    "tasks": "Other Engineering",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.3.1",
    "tasks": "Shop drawings, engineering - All engineering for panel systems, including calculations stamped by a professional engineer.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.3.2",
    "tasks": "Trenches design ( if applicable)",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.3.3",
    "tasks": "Full shading analysis",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.3.4",
    "tasks": "Update of the Structural study provided by the client that the additional load capacity will not affect the structure.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.3.5",
    "tasks": "Temporary facilities layout (if needed).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5",
    "tasks": "PROCUREMENT",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.1",
    "tasks": "Photovoltaics Modules",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.1.1",
    "tasks": "Photovoltaic modules.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.1.2",
    "tasks": "Fenced allocated storage area on site for PV modules.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.2",
    "tasks": "Electrical Equipment",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.2.1",
    "tasks": "LVDB, rapid shutdown, panel board, and disconnect.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.2.2",
    "tasks": "Transformer (if needed).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.2.3",
    "tasks": "Monitoring system.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.3",
    "tasks": "Structure & Mechanical",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.3.1",
    "tasks": "Anchorage, mounting accessories, and fasteners.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.3.2",
    "tasks": "Insulation: 2” Rockwool Cavityrock Exterior Insulation for Cavity Wall and Rainscreen Applications orequal product.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.3.3",
    "tasks": "AWB: Dorken DELTA-STRATUS SA Self-Adhered Water-Resistive Barrier & Air Barrier with High UV Resistance or equal product.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.3.4",
    "tasks": "Flashing at head and jamb of windows as required- 24-gauge single side prepainted galvanized steel cold bended sheets.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.3.5",
    "tasks": "Field applied caulking/sealant with backer rod between Mitrex panels and panel joints only.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.3.6",
    "tasks": "Caulking and backer rod around adjacent materials, and panel return to window, doors, louvers and penetrations.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.7",
    "tasks": "HSE permanent protections.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.8",
    "tasks": "Window sill flashing.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.9",
    "tasks": "Thru-wall or counter flashings.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.10",
    "tasks": "Roofing membrane. Any cap flashing at interface with roofing and structure.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.4",
    "tasks": "Bulk (Cabling and Miscellaneous)",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.4.1",
    "tasks": "Cable trays and conduits.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.2",
    "tasks": "DC cables (Panel to panel).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.3",
    "tasks": "AC cables (Inverter to Point of Interconnection).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.4",
    "tasks": "Communication cables.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.5",
    "tasks": "Earthing cables.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.6",
    "tasks": "Protections (Fuses, MCB).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.5",
    "tasks": "Grid connection",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.5.1",
    "tasks": "LV panel extension works.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6",
    "tasks": "CONSTRUCTION",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.1",
    "tasks": "System Installation",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.1.1",
    "tasks": "Installation of cable trays/conduits.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.1.2",
    "tasks": "Installation of photovoltaic modules including mechanical anchoring and mounting.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.1.3",
    "tasks": "Cutting and patching of slab edges.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.4",
    "tasks": "Spray or liquid applied air or air/vapour barrier.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.1.5",
    "tasks": "Insulation systems.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.1.6",
    "tasks": "Any type of air/vapour barrier tie-ins around any opening such as windows, doors, louvers and penetrations as this is the responsibility of the trade installing such item(s).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.7",
    "tasks": "Installation of wood backing or blocking.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.8",
    "tasks": "Installation of any exterior lighting, cameras, conduits, and all other electrical components.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.9",
    "tasks": "Any / all structural anchors and fasteners.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.1.10",
    "tasks": "Substrate framing, structural supports, structural steel and metal stud framing, structural steelstuds, sheathing products (DensGlass, plywood, etc.), top parapet, top parapet flashing. Systemdepth passing 8” will be considered as a structural component.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.11",
    "tasks": "Leveling the structure and existing walls",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.12",
    "tasks": "Supply or installation of windows or doors",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.13",
    "tasks": "Removal of any overhead obstacles (trees, electrical wiring, cables etc.), exterior lighting, cameras and others which could interfere with the installation of the system.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.14",
    "tasks": "Provisions and maintenance of work areas, storage areas with worksite access and security, and sufficient loading capacity at any time to allow for vehicle and equipment circulation for storage of materials, and removal of snow preventing the access during winter season.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.15",
    "tasks": "Supply or installation of miscellaneous metals such as support shelves, access ladders, railings, bollards and/or fencing, exterior or interior stairs.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.17",
    "tasks": "Provision of security of panels and other materials at the job site.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.2",
    "tasks": "Electrical Installation",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.2.1",
    "tasks": "Electrical material installation (including monitoring system, etc).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.2.2",
    "tasks": "Stringing & PV panel interconnection.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.2.3",
    "tasks": "DC and AC wiring.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.2.4",
    "tasks": "Earthing & all protections system wiring.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.2.5",
    "tasks": "Meter and interface protection installation.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3",
    "tasks": "Other Works",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.3.1",
    "tasks": "PPE and safety harness.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.2",
    "tasks": "Tools & consumables.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.3",
    "tasks": "Scaffolding.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.4",
    "tasks": "Material unloading and shifting to offloading area.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.5",
    "tasks": "Material distribution from offloading area.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.6",
    "tasks": "Temporary site facilities (Toilet, etc).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.7",
    "tasks": "Material handling equipment for unloading and offloading.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.8",
    "tasks": "Materials site storage.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.9",
    "tasks": "Removal of temporary site facilities upon completion.",
    "mitrex": true,
    "client": true
  },
  {
    "item no.": "6.3.10",
    "tasks": "Cleaning of the site upon project completion.",
    "mitrex": true,
    "client": true
  },
  {
    "item no.": "6.4",
    "tasks": "Testing and Commissioning",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.4.1",
    "tasks": "Mechanical acceptance.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.4.2",
    "tasks": "Tests with & without interconnection for hydro commissioning.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.4.3",
    "tasks": "Testing and commissioning.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.4.4",
    "tasks": "Performance test.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "7",
    "tasks": "Other (Delivery, Production, etc)",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "7.1",
    "tasks": "Delivery and packing, crating FOB to job site.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "7.2",
    "tasks": "Attic stock.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.3",
    "tasks": "Road access, crane operation area, or parking permits.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.4",
    "tasks": "Traffic diversion/control fees.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.5",
    "tasks": "Architectural responsibility pertaining to fire, sound, and insulation. (remains in architect’s scope of work).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.6",
    "tasks": "Independent inspections such as geotechnical conditions, concrete, reinforcing steel (re-bar), related materials, mortar, etc.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.7",
    "tasks": "Perimeter foaming.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.8",
    "tasks": "Performance mock-up.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.9",
    "tasks": "Smoke seal.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "7.10",
    "tasks": "Acoustic sealants.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.11",
    "tasks": "Costs associated with use of the material hoist and crane.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.12",
    "tasks": "Construction of or supply of spray racks, chambers, water supply or any other material for field testing.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.13",
    "tasks": "Final cleaning of panel, including removal of stickers/labels, and protective films.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.14",
    "tasks": "All hoarding permits and public protection.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.15",
    "tasks": "Supply and installation of any signage and provision to accommodate the same.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.16",
    "tasks": "Provisions for acoustic insulation and sound dampening materials, either floor-to-floor or room-to-room.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.17",
    "tasks": "Supply of exhaust boxes and vents. Connection of any mechanical components.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.18",
    "tasks": "Responsibility of garbage disposal from site, maintenance of container, and container available on site.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.19",
    "tasks": "Repair of damages made to products/structures by other sub-trades.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.20",
    "tasks": "Preparation of installation areas covered by grass, interlocking, etc.",
    "mitrex": false,
    "client": true
  }
]

const mpaTurnkey = [
  {
    "item no.": "1",
    "tasks": "PROJECT MANAGEMENT",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "1.1",
    "tasks": "Project planning, construction management on site and construction meeting and reporting.",
    "mitrex": true,
    "client": true
  },
  {
    "item no.": "1.2",
    "tasks": "Progress reporting.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "1.3",
    "tasks": "General Coordination of the project with Client.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "1.4",
    "tasks": "Health and safety management.",
    "mitrex": true,
    "client": true
  },
  {
    "item no.": "1.5",
    "tasks": "Coordination between Employer, subcontractors, and authorities (including hydro company).",
    "mitrex": true,
    "client": true
  },
  {
    "item no.": "1.6",
    "tasks": "Construction site insurance.",
    "mitrex": true,
    "client": true
  },
  {
    "item no.": "1.7",
    "tasks": "Construction signage (transportation, warnings).",
    "mitrex": true,
    "client": true
  },
  {
    "item no.": "2",
    "tasks": "DOCUMENTATIONS",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "2.1",
    "tasks": "Safety Induction Documentation.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "2.2",
    "tasks": "Method Statement & Risk Assessment for Installation.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "2.3",
    "tasks": "HSE Compliance Documentation.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "2.4",
    "tasks": "Hydro Commissioning Documentation.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "2.5",
    "tasks": "Markup of IFC drawings for any changes to be incorporated into the as-built drawings.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "3",
    "tasks": "PERMITS",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "3.1",
    "tasks": "Relation and permitting with municipality regarding building permits.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.2",
    "tasks": "Relation and permitting with ESA.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "3.3",
    "tasks": "Relation and permitting with hydro company.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "3.4",
    "tasks": "Hydro Permitting: Engineering, drawings, and documentation.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "3.5",
    "tasks": "Hydro Permitting: Information gathering and coordination.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.6",
    "tasks": "All local and federal government building permit charges.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.7",
    "tasks": "Negotiations with hydro to turn off the high-tension lines and obtain any necessary permits. Assumption of responsibility for the delays occurred because of this omission to do so and payment of any fees relating to that.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4",
    "tasks": "DESIGN",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.1",
    "tasks": "DC Works Engineering",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.1.1",
    "tasks": "General and detailed wiring layout design.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.2",
    "tasks": "Detailed execution drawings design (including earthing layout).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.3",
    "tasks": "Communication design (protocols and wires).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.4",
    "tasks": "Definition of metering devices dedicated to control system and located at Point of Interconnection.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.5",
    "tasks": "Panel and string connection scheme.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.6",
    "tasks": "Transformers definition.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.7",
    "tasks": "AC/DC cables definition wiring with calculation note.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.2",
    "tasks": "AC Works Engineering",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.2.1",
    "tasks": "Basic Design.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.2.2",
    "tasks": "Detailed execution drawings design.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.2.3",
    "tasks": "Equipment and protection definition (included AC Junction Box).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": 4.3,
    "tasks": "Other Engineering",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.3.1",
    "tasks": "Shop drawings, engineering - All engineering for panel systems, including calculations stamped by a professional engineer.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.3.2",
    "tasks": "Trenches design ( if applicable)",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.3.3",
    "tasks": "Full shading analysis",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.3.4",
    "tasks": "Update of the Structural study provided by the client that the additional load capacity will not affect the structure.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.3.5",
    "tasks": "Temporary facilities layout (if needed).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5",
    "tasks": "PROCUREMENT",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.1",
    "tasks": "Photovoltaics Modules",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.1.1",
    "tasks": "Photovoltaic modules.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.1.2",
    "tasks": "Fenced allocated storage area on site for PV modules.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.2",
    "tasks": "Electrical Equipment",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.2.1",
    "tasks": "LVDB, rapid shutdown, panel board, and disconnect.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.2.2",
    "tasks": "Transformer (if needed).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.2.3",
    "tasks": "Monitoring system.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.3",
    "tasks": "Structure & Mechanical",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.3.1",
    "tasks": "Anchorage, mounting accessories, and fasteners.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.3.2",
    "tasks": "Insulation: 2” Rockwool Cavityrock Exterior Insulation for Cavity Wall and Rainscreen Applications orequal product.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.3.3",
    "tasks": "AWB: Dorken DELTA-STRATUS SA Self-Adhered Water-Resistive Barrier & Air Barrier with High UV Resistance or equal product.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.3.4",
    "tasks": "Flashing at head and jamb of windows as required- 24-gauge single side prepainted galvanized steel cold bended sheets.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.3.5",
    "tasks": "Field applied caulking/sealant with backer rod between Mitrex panels and panel joints only.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.3.6",
    "tasks": "Caulking and backer rod around adjacent materials, and panel return to window, doors, louvers and penetrations.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.7",
    "tasks": "HSE permanent protections.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.8",
    "tasks": "Window sill flashing.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.9",
    "tasks": "Thru-wall or counter flashings.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.10",
    "tasks": "Roofing membrane. Any cap flashing at interface with roofing and structure.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.4",
    "tasks": "Bulk (Cabling and Miscellaneous)",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.4.1",
    "tasks": "Cable trays and conduits.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.2",
    "tasks": "DC cables (Panel to panel).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.3",
    "tasks": "AC cables (Inverter to Point of Interconnection).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.4",
    "tasks": "Communication cables.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.5",
    "tasks": "Earthing cables.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.6",
    "tasks": "Protections (Fuses, MCB).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.5",
    "tasks": "Grid connection",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.5.1",
    "tasks": "LV panel extension works.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6",
    "tasks": "CONSTRUCTION",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.1",
    "tasks": "System Installation",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.1.1",
    "tasks": "Installation of cable trays/conduits.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.1.2",
    "tasks": "Installation of photovoltaic modules including mechanical anchoring and mounting.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.1.3",
    "tasks": "Cutting and patching of slab edges.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.4",
    "tasks": "Spray or liquid applied air or air/vapour barrier.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.1.5",
    "tasks": "Insulation systems.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.1.6",
    "tasks": "Any type of air/vapour barrier tie-ins around any opening such as windows, doors, louvers and penetrations as this is the responsibility of the trade installing such item(s).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.7",
    "tasks": "Installation of wood backing or blocking.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.8",
    "tasks": "Installation of any exterior lighting, cameras, conduits, and all other electrical components.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.9",
    "tasks": "Any / all structural anchors and fasteners.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.1.10",
    "tasks": "Substrate framing, structural supports, structural steel and metal stud framing, structural steelstuds, sheathing products (DensGlass, plywood, etc.), top parapet, top parapet flashing. Systemdepth passing 8” will be considered as a structural component.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.11",
    "tasks": "Leveling the structure and existing walls",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.12",
    "tasks": "Supply or installation of windows or doors",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.13",
    "tasks": "Removal of any overhead obstacles (trees, electrical wiring, cables etc.), exterior lighting, cameras and others which could interfere with the installation of the system.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.14",
    "tasks": "Provisions and maintenance of work areas, storage areas with worksite access and security, and sufficient loading capacity at any time to allow for vehicle and equipment circulation for storage of materials, and removal of snow preventing the access during winter season.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.15",
    "tasks": "Supply or installation of miscellaneous metals such as support shelves, access ladders, railings, bollards and/or fencing, exterior or interior stairs.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.17",
    "tasks": "Provision of security of panels and other materials at the job site.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.2",
    "tasks": "Electrical Installation",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.2.1",
    "tasks": "Electrical material installation (including monitoring system, etc).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.2.2",
    "tasks": "Stringing & PV panel interconnection.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.2.3",
    "tasks": "DC and AC wiring.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.2.4",
    "tasks": "Earthing & all protections system wiring.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.2.5",
    "tasks": "Meter and interface protection installation.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3",
    "tasks": "Other Works",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.3.1",
    "tasks": "PPE and safety harness.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.2",
    "tasks": "Tools & consumables.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.3",
    "tasks": "Scaffolding.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.4",
    "tasks": "Material unloading and shifting to offloading area.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.5",
    "tasks": "Material distribution from offloading area.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.6",
    "tasks": "Temporary site facilities (Toilet, etc).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.7",
    "tasks": "Material handling equipment for unloading and offloading.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.8",
    "tasks": "Materials site storage.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.9",
    "tasks": "Removal of temporary site facilities upon completion.",
    "mitrex": true,
    "client": true
  },
  {
    "item no.": "6.3.10",
    "tasks": "Cleaning of the site upon project completion.",
    "mitrex": true,
    "client": true
  },
  {
    "item no.": "6.4",
    "tasks": "Testing and Commissioning",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.4.1",
    "tasks": "Mechanical acceptance.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.4.2",
    "tasks": "Tests with & without interconnection for hydro commissioning.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.4.3",
    "tasks": "Testing and commissioning.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.4.4",
    "tasks": "Performance test.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "7",
    "tasks": "Other (Delivery, Production, etc)",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "7.1",
    "tasks": "Delivery and packing, crating FOB to job site.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "7.2",
    "tasks": "Attic stock.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.3",
    "tasks": "Road access, crane operation area, or parking permits.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.4",
    "tasks": "Traffic diversion/control fees.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.5",
    "tasks": "Architectural responsibility pertaining to fire, sound, and insulation. (remains in architect’s scope of work).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.6",
    "tasks": "Independent inspections such as geotechnical conditions, concrete, reinforcing steel (re-bar), related materials, mortar, etc.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.7",
    "tasks": "Perimeter foaming.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.8",
    "tasks": "Performance mock-up.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.9",
    "tasks": "Smoke seal.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "7.10",
    "tasks": "Acoustic sealants.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.11",
    "tasks": "Costs associated with use of the material hoist and crane.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.12",
    "tasks": "Construction of or supply of spray racks, chambers, water supply or any other material for field testing.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.13",
    "tasks": "Final cleaning of panel, including removal of stickers/labels, and protective films.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.15",
    "tasks": "All hoarding permits and public protection.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.16",
    "tasks": "Supply and installation of any signage and provision to accommodate the same.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.17",
    "tasks": "Provisions for acoustic insulation and sound dampening materials, either floor-to-floor or room-to-room.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.18",
    "tasks": "Supply of exhaust boxes and vents. Connection of any mechanical components.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.19",
    "tasks": "Responsibility of garbage disposal from site, maintenance of container, and container available on site.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.20",
    "tasks": "Repair of damages made to products/structures by other sub-trades.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.21",
    "tasks": "Preparation of installation areas covered by grass, interlocking, etc.",
    "mitrex": false,
    "client": true
  }
]

const panelsOnly = [
  {
    "item no.": "1",
    "tasks": "PROJECT MANAGEMENT",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "1.1",
    "tasks": "Project planning, construction management on site and construction meeting and reporting.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "1.2",
    "tasks": "Progress reporting.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "1.3",
    "tasks": "General Coordination of the project with Client.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "1.4",
    "tasks": "Health and safety management.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "1.5",
    "tasks": "Coordination between Employer, subcontractors, and authorities (including hydro company).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "1.6",
    "tasks": "Construction site insurance.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "1.7",
    "tasks": "Construction signage (transportation, warnings).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "2",
    "tasks": "DOCUMENTATIONS",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "2.1",
    "tasks": "Safety Induction Documentation.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "2.2",
    "tasks": "Method Statement & Risk Assessment for Installation.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "2.3",
    "tasks": "HSE Compliance Documentation.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "2.4",
    "tasks": "Hydro Commissioning Documentation.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "2.5",
    "tasks": "Markup of IFC drawings for any changes to be incorporated into the as-built drawings.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3",
    "tasks": "PERMITS",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "3.1",
    "tasks": "Relation and permitting with municipality regarding building permits.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.2",
    "tasks": "Relation and permitting with ESA.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.3",
    "tasks": "Relation and permitting with hydro company.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.4",
    "tasks": "Hydro Permitting: Engineering, drawings, and documentation.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.5",
    "tasks": "Hydro Permitting: Information gathering and coordination.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.6",
    "tasks": "All local and federal government building permit charges.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.7",
    "tasks": "Negotiations with hydro to turn off the high-tension lines and obtain any necessary permits. Assumption of responsibility for the delays occurred because of this omission to do so and payment of any fees relating to that.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4",
    "tasks": "DESIGN",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.1",
    "tasks": "DC Works Engineering",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.1.1",
    "tasks": "General and detailed wiring layout design.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.1.2",
    "tasks": "Detailed execution drawings design (including earthing layout).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.1.3",
    "tasks": "Communication design (protocols and wires).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.1.4",
    "tasks": "Definition of metering devices dedicated to control system and located at Point of Interconnection.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.1.5",
    "tasks": "Panel and string connection scheme.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.1.6",
    "tasks": "Transformers definition.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.1.7",
    "tasks": "AC/DC cables definition wiring with calculation note.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.2",
    "tasks": "AC Works Engineering",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.2.1",
    "tasks": "Basic Design.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.2.2",
    "tasks": "Detailed execution drawings design.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.2.3",
    "tasks": "Equipment and protection definition (included AC Junction Box).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": 4.3,
    "tasks": "Other Engineering",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.3.1",
    "tasks": "Shop drawings, engineering - All engineering for panel systems, including calculations stamped by a professional engineer.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.3.2",
    "tasks": "Trenches design ( if applicable)",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.3.3",
    "tasks": "Full shading analysis",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.3.4",
    "tasks": "Update of the Structural study provided by the client that the additional load capacity will not affect the structure.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.3.5",
    "tasks": "Temporary facilities layout (if needed).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5",
    "tasks": "PROCUREMENT",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.1",
    "tasks": "Photovoltaics Modules",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.1.1",
    "tasks": "Photovoltaic modules.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.1.2",
    "tasks": "Fenced allocated storage area on site for PV modules.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.2",
    "tasks": "Electrical Equipment",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.2.1",
    "tasks": "LVDB, rapid shutdown, panel board, and disconnect.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.2.2",
    "tasks": "Transformer (if needed).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.2.3",
    "tasks": "Monitoring system.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3",
    "tasks": "Structure & Mechanical",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.3.1",
    "tasks": "Anchorage, mounting accessories, and fasteners.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.2",
    "tasks": "Insulation: 2” Rockwool Cavityrock Exterior Insulation for Cavity Wall and Rainscreen Applications orequal product.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.3",
    "tasks": "AWB: Dorken DELTA-STRATUS SA Self-Adhered Water-Resistive Barrier & Air Barrier with High UV Resistance or equal product.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.4",
    "tasks": "Flashing at head and jamb of windows as required- 24-gauge single side prepainted galvanized steel cold bended sheets.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.5",
    "tasks": "Field applied caulking/sealant with backer rod between Mitrex panels and panel joints only.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.6",
    "tasks": "Caulking and backer rod around adjacent materials, and panel return to window, doors, louvers and penetrations.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.7",
    "tasks": "HSE permanent protections.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.8",
    "tasks": "Window sill flashing.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.9",
    "tasks": "Thru-wall or counter flashings.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.10",
    "tasks": "Roofing membrane. Any cap flashing at interface with roofing and structure.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.4",
    "tasks": "Bulk (Cabling and Miscellaneous)",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.4.1",
    "tasks": "Cable trays and conduits.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.4.2",
    "tasks": "DC cables (Panel to panel).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.4.3",
    "tasks": "AC cables (Inverter to Point of Interconnection).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.4.4",
    "tasks": "Communication cables.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.4.5",
    "tasks": "Earthing cables.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.4.6",
    "tasks": "Protections (Fuses, MCB).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.5",
    "tasks": "Grid connection",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.5.1",
    "tasks": "LV panel extension works.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6",
    "tasks": "CONSTRUCTION",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.1",
    "tasks": "System Installation",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.1.1",
    "tasks": "Installation of cable trays/conduits.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.2",
    "tasks": "Installation of photovoltaic modules including mechanical anchoring and mounting.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.3",
    "tasks": "Cutting and patching of slab edges.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.4",
    "tasks": "Spray or liquid applied air or air/vapour barrier.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.5",
    "tasks": "Insulation systems.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.6",
    "tasks": "Any type of air/vapour barrier tie-ins around any opening such as windows, doors, louvers and penetrations as this is the responsibility of the trade installing such item(s).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.7",
    "tasks": "Installation of wood backing or blocking.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.8",
    "tasks": "Installation of any exterior lighting, cameras, conduits, and all other electrical components.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.9",
    "tasks": "Any / all structural anchors and fasteners.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.10",
    "tasks": "Substrate framing, structural supports, structural steel and metal stud framing, structural steelstuds, sheathing products (DensGlass, plywood, etc.), top parapet, top parapet flashing. Systemdepth passing 8” will be considered as a structural component.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.11",
    "tasks": "Leveling the structure and existing walls",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.12",
    "tasks": "Supply or installation of windows or doors",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.13",
    "tasks": "Removal of any overhead obstacles (trees, electrical wiring, cables etc.), exterior lighting, cameras and others which could interfere with the installation of the system.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.14",
    "tasks": "Provisions and maintenance of work areas, storage areas with worksite access and security, and sufficient loading capacity at any time to allow for vehicle and equipment circulation for storage of materials, and removal of snow preventing the access during winter season.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.15",
    "tasks": "Supply or installation of miscellaneous metals such as support shelves, access ladders, railings, bollards and/or fencing, exterior or interior stairs.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.17",
    "tasks": "Provision of security of panels and other materials at the job site.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.2",
    "tasks": "Electrical Installation",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.2.1",
    "tasks": "Electrical material installation (including monitoring system, etc).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.2.2",
    "tasks": "Stringing & PV panel interconnection.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.2.3",
    "tasks": "DC and AC wiring.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.2.4",
    "tasks": "Earthing & all protections system wiring.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.2.5",
    "tasks": "Meter and interface protection installation.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3",
    "tasks": "Other Works",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.3.1",
    "tasks": "PPE and safety harness.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.2",
    "tasks": "Tools & consumables.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.3",
    "tasks": "Scaffolding.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.4",
    "tasks": "Material unloading and shifting to offloading area.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.5",
    "tasks": "Material distribution from offloading area.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.6",
    "tasks": "Temporary site facilities (Toilet, etc).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.7",
    "tasks": "Material handling equipment for unloading and offloading.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.8",
    "tasks": "Materials site storage.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.9",
    "tasks": "Removal of temporary site facilities upon completion.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.10",
    "tasks": "Cleaning of the site upon project completion.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.4",
    "tasks": "Testing and Commissioning",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.4.1",
    "tasks": "Mechanical acceptance.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.4.2",
    "tasks": "Tests with & without interconnection for hydro commissioning.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.4.3",
    "tasks": "Testing and commissioning.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.4.4",
    "tasks": "Performance test.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7",
    "tasks": "Other (Delivery, Production, etc)",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "7.1",
    "tasks": "Packing.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "7.2",
    "tasks": "Delivery and packing, crating FOB to job site.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.3",
    "tasks": "Attic stock.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.4",
    "tasks": "Road access, crane operation area, or parking permits.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.5",
    "tasks": "Traffic diversion/control fees.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.6",
    "tasks": "Architectural responsibility pertaining to fire, sound, and insulation. (remains in architect’s scope of work).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.7",
    "tasks": "Independent inspections such as geotechnical conditions, concrete, reinforcing steel (re-bar), related materials, mortar, etc.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.8",
    "tasks": "Perimeter foaming.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.9",
    "tasks": "Performance mock-up.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.10",
    "tasks": "Smoke seal.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.11",
    "tasks": "Acoustic sealants.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.12",
    "tasks": "Costs associated with use of the material hoist and crane.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.13",
    "tasks": "Construction of or supply of spray racks, chambers, water supply or any other material for field testing.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.14",
    "tasks": "Final cleaning of panel, including removal of stickers/labels, and protective films.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.15",
    "tasks": "All hoarding permits and public protection.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.16",
    "tasks": "Supply and installation of any signage and provision to accommodate the same.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.17",
    "tasks": "Provisions for acoustic insulation and sound dampening materials, either floor-to-floor or room-to-room.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.18",
    "tasks": "Supply of exhaust boxes and vents. Connection of any mechanical components.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.19",
    "tasks": "Responsibility of garbage disposal from site, maintenance of container, and container available on site.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.20",
    "tasks": "Repair of damages made to products/structures by other sub-trades.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.21",
    "tasks": "Preparation of installation areas covered by grass, interlocking, etc.",
    "mitrex": false,
    "client": true
  }
]

const panelsElectrical = [
  {
    "item no.": "1",
    "tasks": "PROJECT MANAGEMENT",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "1.1",
    "tasks": "Project planning, construction management on site and construction meeting and reporting.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "1.2",
    "tasks": "Progress reporting.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "1.3",
    "tasks": "General Coordination of the project with Client.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "1.4",
    "tasks": "Health and safety management.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "1.5",
    "tasks": "Coordination between Employer, subcontractors, and authorities (including hydro company).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "1.6",
    "tasks": "Construction site insurance.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "1.7",
    "tasks": "Construction signage (transportation, warnings).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "2",
    "tasks": "DOCUMENTATIONS",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "2.1",
    "tasks": "Safety Induction Documentation.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "2.2",
    "tasks": "Method Statement & Risk Assessment for Installation.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "2.3",
    "tasks": "HSE Compliance Documentation.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "2.4",
    "tasks": "Hydro Commissioning Documentation.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "2.5",
    "tasks": "Markup of IFC drawings for any changes to be incorporated into the as-built drawings.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3",
    "tasks": "PERMITS",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "3.1",
    "tasks": "Relation and permitting with municipality regarding building permits.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.2",
    "tasks": "Relation and permitting with ESA.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.3",
    "tasks": "Relation and permitting with hydro company.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.4",
    "tasks": "Hydro Permitting: Engineering, drawings, and documentation.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.5",
    "tasks": "Hydro Permitting: Information gathering and coordination.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.6",
    "tasks": "All local and federal government building permit charges.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.7",
    "tasks": "Negotiations with hydro to turn off the high-tension lines and obtain any necessary permits. Assumption of responsibility for the delays occurred because of this omission to do so and payment of any fees relating to that.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4",
    "tasks": "DESIGN",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.1",
    "tasks": "DC Works Engineering",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.1.1",
    "tasks": "General and detailed wiring layout design.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.1.2",
    "tasks": "Detailed execution drawings design (including earthing layout).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.1.3",
    "tasks": "Communication design (protocols and wires).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.1.4",
    "tasks": "Definition of metering devices dedicated to control system and located at Point of Interconnection.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.1.5",
    "tasks": "Panel and string connection scheme.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.1.6",
    "tasks": "Transformers definition.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.1.7",
    "tasks": "AC/DC cables definition wiring with calculation note.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.2",
    "tasks": "AC Works Engineering",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.2.1",
    "tasks": "Basic Design.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.2.2",
    "tasks": "Detailed execution drawings design.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.2.3",
    "tasks": "Equipment and protection definition (included AC Junction Box).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": 4.3,
    "tasks": "Other Engineering",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.3.1",
    "tasks": "Shop drawings, engineering - All engineering for panel systems, including calculations stamped by a professional engineer.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.3.2",
    "tasks": "Trenches design ( if applicable)",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.3.3",
    "tasks": "Full shading analysis",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.3.4",
    "tasks": "Update of the Structural study provided by the client that the additional load capacity will not affect the structure.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.3.5",
    "tasks": "Temporary facilities layout (if needed).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5",
    "tasks": "PROCUREMENT",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.1",
    "tasks": "Photovoltaics Modules",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.1.1",
    "tasks": "Photovoltaic modules.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.1.2",
    "tasks": "Fenced allocated storage area on site for PV modules.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.2",
    "tasks": "Electrical Equipment",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.2.1",
    "tasks": "LVDB, rapid shutdown, panel board, and disconnect.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.2.2",
    "tasks": "Transformer (if needed).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.2.3",
    "tasks": "Monitoring system.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.3",
    "tasks": "Structure & Mechanical",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.3.1",
    "tasks": "Anchorage, mounting accessories, and fasteners.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.2",
    "tasks": "Insulation: 2” Rockwool Cavityrock Exterior Insulation for Cavity Wall and Rainscreen Applications orequal product.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.3",
    "tasks": "AWB: Dorken DELTA-STRATUS SA Self-Adhered Water-Resistive Barrier & Air Barrier with High UV Resistance or equal product.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.4",
    "tasks": "Flashing at head and jamb of windows as required- 24-gauge single side prepainted galvanized steel cold bended sheets.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.5",
    "tasks": "Field applied caulking/sealant with backer rod between Mitrex panels and panel joints only.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.6",
    "tasks": "Caulking and backer rod around adjacent materials, and panel return to window, doors, louvers and penetrations.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.7",
    "tasks": "HSE permanent protections.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.8",
    "tasks": "Window sill flashing.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.9",
    "tasks": "Thru-wall or counter flashings.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.10",
    "tasks": "Roofing membrane. Any cap flashing at interface with roofing and structure.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.4",
    "tasks": "Bulk (Cabling and Miscellaneous)",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.4.1",
    "tasks": "Cable trays and conduits.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.2",
    "tasks": "DC cables (Panel to panel).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.3",
    "tasks": "AC cables (Inverter to Point of Interconnection).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.4",
    "tasks": "Communication cables.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.5",
    "tasks": "Earthing cables.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.6",
    "tasks": "Protections (Fuses, MCB).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.5",
    "tasks": "Grid connection",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.5.1",
    "tasks": "LV panel extension works.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6",
    "tasks": "CONSTRUCTION",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.1",
    "tasks": "System Installation",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.1.1",
    "tasks": "Installation of cable trays/conduits.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.2",
    "tasks": "Installation of photovoltaic modules including mechanical anchoring and mounting.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.3",
    "tasks": "Cutting and patching of slab edges.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.4",
    "tasks": "Spray or liquid applied air or air/vapour barrier.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.5",
    "tasks": "Insulation systems.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.6",
    "tasks": "Any type of air/vapour barrier tie-ins around any opening such as windows, doors, louvers and penetrations as this is the responsibility of the trade installing such item(s).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.7",
    "tasks": "Installation of wood backing or blocking.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.8",
    "tasks": "Installation of any exterior lighting, cameras, conduits, and all other electrical components.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.9",
    "tasks": "Any / all structural anchors and fasteners.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.10",
    "tasks": "Substrate framing, structural supports, structural steel and metal stud framing, structural steelstuds, sheathing products (DensGlass, plywood, etc.), top parapet, top parapet flashing. Systemdepth passing 8” will be considered as a structural component.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.11",
    "tasks": "Leveling the structure and existing walls",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.12",
    "tasks": "Supply or installation of windows or doors",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.13",
    "tasks": "Removal of any overhead obstacles (trees, electrical wiring, cables etc.), exterior lighting, cameras and others which could interfere with the installation of the system.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.14",
    "tasks": "Provisions and maintenance of work areas, storage areas with worksite access and security, and sufficient loading capacity at any time to allow for vehicle and equipment circulation for storage of materials, and removal of snow preventing the access during winter season.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.15",
    "tasks": "Supply or installation of miscellaneous metals such as support shelves, access ladders, railings, bollards and/or fencing, exterior or interior stairs.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.17",
    "tasks": "Provision of security of panels and other materials at the job site.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.2",
    "tasks": "Electrical Installation",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.2.1",
    "tasks": "Electrical material installation (including monitoring system, etc).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.2.2",
    "tasks": "Stringing & PV panel interconnection.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.2.3",
    "tasks": "DC and AC wiring.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.2.4",
    "tasks": "Earthing & all protections system wiring.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.2.5",
    "tasks": "Meter and interface protection installation.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3",
    "tasks": "Other Works",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.3.1",
    "tasks": "PPE and safety harness.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.2",
    "tasks": "Tools & consumables.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.3",
    "tasks": "Scaffolding.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.4",
    "tasks": "Material unloading and shifting to offloading area.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.5",
    "tasks": "Material distribution from offloading area.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.6",
    "tasks": "Temporary site facilities (Toilet, etc).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.7",
    "tasks": "Material handling equipment for unloading and offloading.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.8",
    "tasks": "Materials site storage.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.9",
    "tasks": "Removal of temporary site facilities upon completion.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.10",
    "tasks": "Cleaning of the site upon project completion.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.4",
    "tasks": "Testing and Commissioning",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.4.1",
    "tasks": "Mechanical acceptance.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.4.2",
    "tasks": "Tests with & without interconnection for hydro commissioning.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.4.3",
    "tasks": "Testing and commissioning.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.4.4",
    "tasks": "Performance test.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7",
    "tasks": "Other (Delivery, Production, etc)",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "7.1",
    "tasks": "Packing.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "7.2",
    "tasks": "Delivery and packing, crating FOB to job site.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.3",
    "tasks": "Attic stock.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.4",
    "tasks": "Road access, crane operation area, or parking permits.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.5",
    "tasks": "Traffic diversion/control fees.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.6",
    "tasks": "Architectural responsibility pertaining to fire, sound, and insulation. (remains in architect’s scope of work).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.7",
    "tasks": "Independent inspections such as geotechnical conditions, concrete, reinforcing steel (re-bar), related materials, mortar, etc.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.8",
    "tasks": "Perimeter foaming.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.9",
    "tasks": "Performance mock-up.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.10",
    "tasks": "Smoke seal.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.11",
    "tasks": "Acoustic sealants.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.12",
    "tasks": "Costs associated with use of the material hoist and crane.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.13",
    "tasks": "Construction of or supply of spray racks, chambers, water supply or any other material for field testing.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.14",
    "tasks": "Final cleaning of panel, including removal of stickers/labels, and protective films.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.15",
    "tasks": "All hoarding permits and public protection.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.16",
    "tasks": "Supply and installation of any signage and provision to accommodate the same.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.17",
    "tasks": "Provisions for acoustic insulation and sound dampening materials, either floor-to-floor or room-to-room.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.18",
    "tasks": "Supply of exhaust boxes and vents. Connection of any mechanical components.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.19",
    "tasks": "Responsibility of garbage disposal from site, maintenance of container, and container available on site.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.20",
    "tasks": "Repair of damages made to products/structures by other sub-trades.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.21",
    "tasks": "Preparation of installation areas covered by grass, interlocking, etc.",
    "mitrex": false,
    "client": true
  }
]

const panelsElectricalCladding = [
  {
    "item no.": "1",
    "tasks": "PROJECT MANAGEMENT",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "1.1",
    "tasks": "Project planning, construction management on site and construction meeting and reporting.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "1.2",
    "tasks": "Progress reporting.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "1.3",
    "tasks": "General Coordination of the project with Client.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "1.4",
    "tasks": "Health and safety management.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "1.5",
    "tasks": "Coordination between Employer, subcontractors, and authorities (including hydro company).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "1.6",
    "tasks": "Construction site insurance.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "1.7",
    "tasks": "Construction signage (transportation, warnings).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "2",
    "tasks": "DOCUMENTATIONS",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "2.1",
    "tasks": "Safety Induction Documentation.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "2.2",
    "tasks": "Method Statement & Risk Assessment for Installation.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "2.3",
    "tasks": "HSE Compliance Documentation.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "2.4",
    "tasks": "Hydro Commissioning Documentation.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "2.5",
    "tasks": "Markup of IFC drawings for any changes to be incorporated into the as-built drawings.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3",
    "tasks": "PERMITS",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "3.1",
    "tasks": "Relation and permitting with municipality regarding building permits.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.2",
    "tasks": "Relation and permitting with ESA.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.3",
    "tasks": "Relation and permitting with hydro company.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.4",
    "tasks": "Hydro Permitting: Engineering, drawings, and documentation.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.5",
    "tasks": "Hydro Permitting: Information gathering and coordination.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.6",
    "tasks": "All local and federal government building permit charges.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.7",
    "tasks": "Negotiations with hydro to turn off the high-tension lines and obtain any necessary permits. Assumption of responsibility for the delays occurred because of this omission to do so and payment of any fees relating to that.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4",
    "tasks": "DESIGN",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.1",
    "tasks": "DC Works Engineering",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.1.1",
    "tasks": "General and detailed wiring layout design.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.2",
    "tasks": "Detailed execution drawings design (including earthing layout).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.3",
    "tasks": "Communication design (protocols and wires).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.4",
    "tasks": "Definition of metering devices dedicated to control system and located at Point of Interconnection.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.5",
    "tasks": "Panel and string connection scheme.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.6",
    "tasks": "Transformers definition.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.7",
    "tasks": "AC/DC cables definition wiring with calculation note.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.2",
    "tasks": "AC Works Engineering",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.2.1",
    "tasks": "Basic Design.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.2.2",
    "tasks": "Detailed execution drawings design.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.2.3",
    "tasks": "Equipment and protection definition (included AC Junction Box).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": 4.3,
    "tasks": "Other Engineering",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.3.1",
    "tasks": "Shop drawings, engineering - All engineering for panel systems, including calculations stamped by a professional engineer.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.3.2",
    "tasks": "Trenches design ( if applicable)",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4.3.3",
    "tasks": "Full shading analysis",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.3.4",
    "tasks": "Update of the Structural study provided by the client that the additional load capacity will not affect the structure.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.3.5",
    "tasks": "Temporary facilities layout (if needed).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5",
    "tasks": "PROCUREMENT",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.1",
    "tasks": "Photovoltaics Modules",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.1.1",
    "tasks": "Photovoltaic modules.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.1.2",
    "tasks": "Fenced allocated storage area on site for PV modules.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.2",
    "tasks": "Electrical Equipment",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.2.1",
    "tasks": "LVDB, rapid shutdown, panel board, and disconnect.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.2.2",
    "tasks": "Transformer (if needed).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.2.3",
    "tasks": "Monitoring system.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.3",
    "tasks": "Structure & Mechanical",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.3.1",
    "tasks": "Anchorage, mounting accessories, and fasteners.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.3.2",
    "tasks": "Insulation: 2” Rockwool Cavityrock Exterior Insulation for Cavity Wall and Rainscreen Applications orequal product.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.3",
    "tasks": "AWB: Dorken DELTA-STRATUS SA Self-Adhered Water-Resistive Barrier & Air Barrier with High UV Resistance or equal product.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.4",
    "tasks": "Flashing at head and jamb of windows as required- 24-gauge single side prepainted galvanized steel cold bended sheets.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.5",
    "tasks": "Field applied caulking/sealant with backer rod between Mitrex panels and panel joints only.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.6",
    "tasks": "Caulking and backer rod around adjacent materials, and panel return to window, doors, louvers and penetrations.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.7",
    "tasks": "HSE permanent protections.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.8",
    "tasks": "Window sill flashing.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.9",
    "tasks": "Thru-wall or counter flashings.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.10",
    "tasks": "Roofing membrane. Any cap flashing at interface with roofing and structure.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.4",
    "tasks": "Bulk (Cabling and Miscellaneous)",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.4.1",
    "tasks": "Cable trays and conduits.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.2",
    "tasks": "DC cables (Panel to panel).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.3",
    "tasks": "AC cables (Inverter to Point of Interconnection).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.4",
    "tasks": "Communication cables.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.5",
    "tasks": "Earthing cables.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.6",
    "tasks": "Protections (Fuses, MCB).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.5",
    "tasks": "Grid connection",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.5.1",
    "tasks": "LV panel extension works.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6",
    "tasks": "CONSTRUCTION",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.1",
    "tasks": "System Installation",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.1.1",
    "tasks": "Installation of cable trays/conduits.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.2",
    "tasks": "Installation of photovoltaic modules including mechanical anchoring and mounting.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.3",
    "tasks": "Cutting and patching of slab edges.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.4",
    "tasks": "Spray or liquid applied air or air/vapour barrier.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.5",
    "tasks": "Insulation systems.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.6",
    "tasks": "Any type of air/vapour barrier tie-ins around any opening such as windows, doors, louvers and penetrations as this is the responsibility of the trade installing such item(s).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.7",
    "tasks": "Installation of wood backing or blocking.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.8",
    "tasks": "Installation of any exterior lighting, cameras, conduits, and all other electrical components.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.9",
    "tasks": "Any / all structural anchors and fasteners.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.10",
    "tasks": "Substrate framing, structural supports, structural steel and metal stud framing, structural steelstuds, sheathing products (DensGlass, plywood, etc.), top parapet, top parapet flashing. Systemdepth passing 8” will be considered as a structural component.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.11",
    "tasks": "Leveling the structure and existing walls",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.12",
    "tasks": "Supply or installation of windows or doors",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.13",
    "tasks": "Removal of any overhead obstacles (trees, electrical wiring, cables etc.), exterior lighting, cameras and others which could interfere with the installation of the system.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.14",
    "tasks": "Provisions and maintenance of work areas, storage areas with worksite access and security, and sufficient loading capacity at any time to allow for vehicle and equipment circulation for storage of materials, and removal of snow preventing the access during winter season.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.15",
    "tasks": "Supply or installation of miscellaneous metals such as support shelves, access ladders, railings, bollards and/or fencing, exterior or interior stairs.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.17",
    "tasks": "Provision of security of panels and other materials at the job site.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.2",
    "tasks": "Electrical Installation",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.2.1",
    "tasks": "Electrical material installation (including monitoring system, etc).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.2.2",
    "tasks": "Stringing & PV panel interconnection.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.2.3",
    "tasks": "DC and AC wiring.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.2.4",
    "tasks": "Earthing & all protections system wiring.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.2.5",
    "tasks": "Meter and interface protection installation.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3",
    "tasks": "Other Works",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.3.1",
    "tasks": "PPE and safety harness.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.2",
    "tasks": "Tools & consumables.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.3",
    "tasks": "Scaffolding.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.4",
    "tasks": "Material unloading and shifting to offloading area.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.5",
    "tasks": "Material distribution from offloading area.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.6",
    "tasks": "Temporary site facilities (Toilet, etc).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.7",
    "tasks": "Material handling equipment for unloading and offloading.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.8",
    "tasks": "Materials site storage.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.9",
    "tasks": "Removal of temporary site facilities upon completion.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.10",
    "tasks": "Cleaning of the site upon project completion.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.4",
    "tasks": "Testing and Commissioning",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.4.1",
    "tasks": "Mechanical acceptance.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.4.2",
    "tasks": "Tests with & without interconnection for hydro commissioning.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.4.3",
    "tasks": "Testing and commissioning.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.4.4",
    "tasks": "Performance test.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7",
    "tasks": "Other (Delivery, Production, etc)",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "7.1",
    "tasks": "Packing.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "7.2",
    "tasks": "Delivery and packing, crating FOB to job site.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.3",
    "tasks": "Attic stock.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.4",
    "tasks": "Road access, crane operation area, or parking permits.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.5",
    "tasks": "Traffic diversion/control fees.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.6",
    "tasks": "Architectural responsibility pertaining to fire, sound, and insulation. (remains in architect’s scope of work).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.7",
    "tasks": "Independent inspections such as geotechnical conditions, concrete, reinforcing steel (re-bar), related materials, mortar, etc.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.8",
    "tasks": "Perimeter foaming.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.9",
    "tasks": "Performance mock-up.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.10",
    "tasks": "Smoke seal.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.11",
    "tasks": "Acoustic sealants.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.12",
    "tasks": "Costs associated with use of the material hoist and crane.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.13",
    "tasks": "Construction of or supply of spray racks, chambers, water supply or any other material for field testing.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.14",
    "tasks": "Final cleaning of panel, including removal of stickers/labels, and protective films.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.15",
    "tasks": "All hoarding permits and public protection.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.16",
    "tasks": "Supply and installation of any signage and provision to accommodate the same.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.17",
    "tasks": "Provisions for acoustic insulation and sound dampening materials, either floor-to-floor or room-to-room.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.18",
    "tasks": "Supply of exhaust boxes and vents. Connection of any mechanical components.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.19",
    "tasks": "Responsibility of garbage disposal from site, maintenance of container, and container available on site.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.20",
    "tasks": "Repair of damages made to products/structures by other sub-trades.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.21",
    "tasks": "Preparation of installation areas covered by grass, interlocking, etc.",
    "mitrex": false,
    "client": true
  }
]

const cladicast = [
  {
    "item no.": "1",
    "tasks": "PROJECT MANAGEMENT",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "1.1",
    "tasks": "Project planning, construction management on site and construction meeting and reporting.",
    "mitrex": true,
    "client": true
  },
  {
    "item no.": "1.2",
    "tasks": "Progress reporting.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "1.3",
    "tasks": "General Coordination of the project with Client.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "1.4",
    "tasks": "Health and safety management.",
    "mitrex": true,
    "client": true
  },
  {
    "item no.": "1.5",
    "tasks": "Coordination between Employer, subcontractors, and authorities (including hydro company).",
    "mitrex": true,
    "client": true
  },
  {
    "item no.": "1.6",
    "tasks": "Construction site insurance.",
    "mitrex": true,
    "client": true
  },
  {
    "item no.": "1.7",
    "tasks": "Construction signage (transportation, warnings).",
    "mitrex": true,
    "client": true
  },
  {
    "item no.": "2",
    "tasks": "DOCUMENTATIONS",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "2.1",
    "tasks": "Safety Induction Documentation.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "2.2",
    "tasks": "Method Statement & Risk Assessment for Installation.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "2.3",
    "tasks": "HSE Compliance Documentation.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "2.4",
    "tasks": "Hydro Commissioning Documentation.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "2.5",
    "tasks": "Markup of IFC drawings for any changes to be incorporated into the as-built drawings.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "3",
    "tasks": "PERMITS",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "3.1",
    "tasks": "Relation and permitting with municipality regarding building permits.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.2",
    "tasks": "Relation and permitting with ESA.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "3.3",
    "tasks": "Relation and permitting with hydro company.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "3.4",
    "tasks": "Hydro Permitting: Engineering, drawings, and documentation.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "3.5",
    "tasks": "Hydro Permitting: Information gathering and coordination.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.6",
    "tasks": "All local and federal government building permit charges.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "3.7",
    "tasks": "Negotiations with hydro to turn off the high-tension lines and obtain any necessary permits. Assumption of responsibility for the delays occurred because of this omission to do so and payment of any fees relating to that.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "4",
    "tasks": "DESIGN",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.1",
    "tasks": "DC Works Engineering",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.1.1",
    "tasks": "General and detailed wiring layout design.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.2",
    "tasks": "Detailed execution drawings design (including earthing layout).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.3",
    "tasks": "Communication design (protocols and wires).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.4",
    "tasks": "Definition of metering devices dedicated to control system and located at Point of Interconnection.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.5",
    "tasks": "Panel and string connection scheme.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.6",
    "tasks": "Transformers definition.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.1.7",
    "tasks": "AC/DC cables definition wiring with calculation note.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.2",
    "tasks": "AC Works Engineering",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.2.1",
    "tasks": "Basic Design.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.2.2",
    "tasks": "Detailed execution drawings design.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.2.3",
    "tasks": "Equipment and protection definition (included AC Junction Box).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": 4.3,
    "tasks": "Other Engineering",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "4.3.1",
    "tasks": "Shop drawings, engineering - All engineering for panel systems, including calculations stamped by a professional engineer.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.3.2",
    "tasks": "Trenches design ( if applicable)",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.3.3",
    "tasks": "Full shading analysis",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.3.4",
    "tasks": "Update of the Structural study provided by the client that the additional load capacity will not affect the structure.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "4.3.5",
    "tasks": "Temporary facilities layout (if needed).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5",
    "tasks": "PROCUREMENT",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.1",
    "tasks": "Photovoltaics Modules",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.1.1",
    "tasks": "Photovoltaic modules.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.1.2",
    "tasks": "Fenced allocated storage area on site for PV modules.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.2",
    "tasks": "Electrical Equipment",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.2.1",
    "tasks": "LVDB, rapid shutdown, panel board, and disconnect.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.2.2",
    "tasks": "Transformer (if needed).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.2.3",
    "tasks": "Monitoring system.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.3",
    "tasks": "Structure & Mechanical",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.3.1",
    "tasks": "Anchorage, mounting accessories, and fasteners.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.3.2",
    "tasks": "Insulation: 2” Rockwool Cavityrock Exterior Insulation for Cavity Wall and Rainscreen Applications orequal product.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.3",
    "tasks": "AWB: Dorken DELTA-STRATUS SA Self-Adhered Water-Resistive Barrier & Air Barrier with High UV Resistance or equal product.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.4",
    "tasks": "Flashing at head and jamb of windows as required- 24-gauge single side prepainted galvanized steel cold bended sheets.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.5",
    "tasks": "Field applied caulking/sealant with backer rod between Mitrex panels and panel joints only.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.6",
    "tasks": "Caulking and backer rod around adjacent materials, and panel return to window, doors, louvers and penetrations.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.7",
    "tasks": "HSE permanent protections.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.8",
    "tasks": "Window sill flashing.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.9",
    "tasks": "Thru-wall or counter flashings.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.3.10",
    "tasks": "Roofing membrane. Any cap flashing at interface with roofing and structure.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "5.4",
    "tasks": "Bulk (Cabling and Miscellaneous)",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.4.1",
    "tasks": "Cable trays and conduits.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.2",
    "tasks": "DC cables (Panel to panel).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.3",
    "tasks": "AC cables (Inverter to Point of Interconnection).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.4",
    "tasks": "Communication cables.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.5",
    "tasks": "Earthing cables.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.4.6",
    "tasks": "Protections (Fuses, MCB).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "5.5",
    "tasks": "Grid connection",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "5.5.1",
    "tasks": "LV panel extension works.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6",
    "tasks": "CONSTRUCTION",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.1",
    "tasks": "System Installation",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.1.1",
    "tasks": "Installation of cable trays/conduits.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.1.2",
    "tasks": "Installation of photovoltaic modules including mechanical anchoring and mounting.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.1.3",
    "tasks": "Cutting and patching of slab edges.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.4",
    "tasks": "Spray or liquid applied air or air/vapour barrier.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.5",
    "tasks": "Insulation systems.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.6",
    "tasks": "Any type of air/vapour barrier tie-ins around any opening such as windows, doors, louvers and penetrations as this is the responsibility of the trade installing such item(s).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.7",
    "tasks": "Installation of wood backing or blocking.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.8",
    "tasks": "Installation of any exterior lighting, cameras, conduits, and all other electrical components.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.9",
    "tasks": "Any / all structural anchors and fasteners.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.1.10",
    "tasks": "Substrate framing, structural supports, structural steel and metal stud framing, structural steelstuds, sheathing products (DensGlass, plywood, etc.), top parapet, top parapet flashing. Systemdepth passing 8” will be considered as a structural component.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.11",
    "tasks": "Leveling the structure and existing walls",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.12",
    "tasks": "Supply or installation of windows or doors",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.13",
    "tasks": "Removal of any overhead obstacles (trees, electrical wiring, cables etc.), exterior lighting, cameras and others which could interfere with the installation of the system.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.14",
    "tasks": "Provisions and maintenance of work areas, storage areas with worksite access and security, and sufficient loading capacity at any time to allow for vehicle and equipment circulation for storage of materials, and removal of snow preventing the access during winter season.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.15",
    "tasks": "Supply or installation of miscellaneous metals such as support shelves, access ladders, railings, bollards and/or fencing, exterior or interior stairs.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.1.17",
    "tasks": "Provision of security of panels and other materials at the job site.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.2",
    "tasks": "Electrical Installation",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.2.1",
    "tasks": "Electrical material installation (including monitoring system, etc).",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.2.2",
    "tasks": "Stringing & PV panel interconnection.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.2.3",
    "tasks": "DC and AC wiring.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.2.4",
    "tasks": "Earthing & all protections system wiring.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.2.5",
    "tasks": "Meter and interface protection installation.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3",
    "tasks": "Other Works",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.3.1",
    "tasks": "PPE and safety harness.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.2",
    "tasks": "Tools & consumables.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.3",
    "tasks": "Scaffolding.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.4",
    "tasks": "Material unloading and shifting to offloading area.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.5",
    "tasks": "Material distribution from offloading area.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.6",
    "tasks": "Temporary site facilities (Toilet, etc).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "6.3.7",
    "tasks": "Material handling equipment for unloading and offloading.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.8",
    "tasks": "Materials site storage.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.3.9",
    "tasks": "Removal of temporary site facilities upon completion.",
    "mitrex": true,
    "client": true
  },
  {
    "item no.": "6.3.10",
    "tasks": "Cleaning of the site upon project completion.",
    "mitrex": true,
    "client": true
  },
  {
    "item no.": "6.4",
    "tasks": "Testing and Commissioning",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "6.4.1",
    "tasks": "Mechanical acceptance.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.4.2",
    "tasks": "Tests with & without interconnection for hydro commissioning.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.4.3",
    "tasks": "Testing and commissioning.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "6.4.4",
    "tasks": "Performance test.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "7",
    "tasks": "Other (Delivery, Production, etc)",
    "mitrex": "",
    "client": ""
  },
  {
    "item no.": "7.1",
    "tasks": "Delivery and packing, crating FOB to job site.",
    "mitrex": true,
    "client": false
  },
  {
    "item no.": "7.2",
    "tasks": "Attic stock.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.3",
    "tasks": "Road access, crane operation area, or parking permits.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.4",
    "tasks": "Traffic diversion/control fees.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.5",
    "tasks": "Architectural responsibility pertaining to fire, sound, and insulation. (remains in architect’s scope of work).",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.6",
    "tasks": "Independent inspections such as geotechnical conditions, concrete, reinforcing steel (re-bar), related materials, mortar, etc.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.7",
    "tasks": "Perimeter foaming.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.8",
    "tasks": "Performance mock-up.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.9",
    "tasks": "Smoke seal.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.10",
    "tasks": "Acoustic sealants.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.11",
    "tasks": "Costs associated with use of the material hoist and crane.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.12",
    "tasks": "Construction of or supply of spray racks, chambers, water supply or any other material for field testing.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.13",
    "tasks": "Final cleaning of panel, including removal of stickers/labels, and protective films.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.14",
    "tasks": "All hoarding permits and public protection.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.15",
    "tasks": "Supply and installation of any signage and provision to accommodate the same.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.16",
    "tasks": "Provisions for acoustic insulation and sound dampening materials, either floor-to-floor or room-to-room.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.17",
    "tasks": "Supply of exhaust boxes and vents. Connection of any mechanical components.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.18",
    "tasks": "Responsibility of garbage disposal from site, maintenance of container, and container available on site.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.19",
    "tasks": "Repair of damages made to products/structures by other sub-trades.",
    "mitrex": false,
    "client": true
  },
  {
    "item no.": "7.20",
    "tasks": "Preparation of installation areas covered by grass, interlocking, etc.",
    "mitrex": false,
    "client": true
  }
]

const supplyOnly = [
  {
    "item no.": "1",
    "tasks": "PROJECT MANAGEMENT",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "1.1",
    "tasks": "Project planning, construction management on site and construction meeting and reporting.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "1.2",
    "tasks": "Progress reporting.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "1.3",
    "tasks": "General Coordination of the project with Client.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "1.4",
    "tasks": "Health and safety management.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "1.5",
    "tasks": "Coordination between Employer, subcontractors, and authorities.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "1.6",
    "tasks": "Construction site insurance.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "1.7",
    "tasks": "Construction signage (transportation, warnings).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "2",
    "tasks": "DOCUMENTATIONS",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "2.1",
    "tasks": "Safety Induction Documentation.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "2.2",
    "tasks": "Method Statement & Risk Assessment for Installation.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "2.3",
    "tasks": "HSE Compliance Documentation.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "2.4",
    "tasks": "Markup of IFC drawings for any changes to be incorporated into the as-built drawings.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "3",
    "tasks": "PERMITS",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "3.1",
    "tasks": "Relation and permitting with municipality regarding building permits.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "3.2",
    "tasks": "All local and federal government building permit charges.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "4",
    "tasks": "DESIGN",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "4.1",
    "tasks": "Engineering",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "4.1.1",
    "tasks": "Shop drawings, engineering - All engineering for panel systems, including calculations stamped by a professional engineer.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "4.1.2",
    "tasks": "Update of the Structural study provided by the client that the additional load capacity will not affect the structure.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "4.1.3",
    "tasks": "Temporary facilities layout (if needed).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5",
    "tasks": "PROCUREMENT",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "5.1",
    "tasks": "Modules",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "5.1.1",
    "tasks": "Modules.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.1.2",
    "tasks": "Fenced allocated storage area on site for modules.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2",
    "tasks": "Structure & Mechanical",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "5.2.1",
    "tasks": "Anchorage, mounting accessories, and fasteners.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.2",
    "tasks": "Interlocking channels.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.3",
    "tasks": "L-Bars.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.4",
    "tasks": "Thermal Breaks.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.5",
    "tasks": "Insulation: 2” Rockwool Cavityrock Exterior Insulation for Cavity Wall and Rainscreen Applications or equal product.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.6",
    "tasks": "AWB: Dorken DELTA-STRATUS SA Self-Adhered Water-Resistive Barrier & Air Barrier with High UV Resistance or equal product.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.7",
    "tasks": "Flashing at head and jamb of windows as required- 24-gauge single side prepainted galvanized steel cold bended sheets.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.8",
    "tasks": "Field applied caulking/sealant with backer rod between Cladify panels and panel joints only.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.9",
    "tasks": "Caulking and backer rod around adjacent materials, and panel return to window, doors, louvers and penetrations.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.10",
    "tasks": "HSE permanent protections.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.11",
    "tasks": "Window sill flashing.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.12",
    "tasks": "Thru-wall or counter flashings.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.13",
    "tasks": "Roofing membrane. Any cap flashing at interface with roofing and structure.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6",
    "tasks": "CONSTRUCTION",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.1",
    "tasks": "System Installation",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.1.1",
    "tasks": "Installation of modules including mechanical anchoring and mounting.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.2",
    "tasks": "Cutting and patching of slab edges.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.3",
    "tasks": "Spray or liquid applied air or air/vapour barrier.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.4",
    "tasks": "Insulation systems.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.5",
    "tasks": "Any type of air/vapour barrier tie-ins around any opening such as windows, doors, louvers and penetrations as this is the responsibility of the trade installing such item(s).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.6",
    "tasks": "Installation of wood backing or blocking.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.7",
    "tasks": "Installation of any exterior lighting, cameras, conduits, and all other electrical components.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.8",
    "tasks": "Any / all structural anchors and fasteners.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.9",
    "tasks": "Substrate framing, structural supports, structural steel and metal stud framing, structural steel studs, sheathing products (DensGlass, plywood, etc.), top parapet, top parapet flashing. System depth passing 8” will be considered as a structural component.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.10",
    "tasks": "Leveling the structure and existing walls.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.11",
    "tasks": "Supply or installation of windows or doors.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.12",
    "tasks": "Removal of any overhead obstacles (trees, electrical wiring, cables etc.), exterior lighting, cameras and others which could interfere with the installation of the system.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.13",
    "tasks": "Provisions and maintenance of work areas, storage areas with worksite access and security, and sufficient loading capacity at any time to allow for vehicle and equipment circulation for storage of materials, and removal of snow preventing the access during winter season.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.14",
    "tasks": "Supply or installation of miscellaneous metals such as support shelves, access ladders, railings, bollards and/or fencing, exterior or interior stairs.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.15",
    "tasks": "Provision of security of panels and other materials at the job site.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2",
    "tasks": "Other Works",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.2.1",
    "tasks": "PPE and safety harness.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.2",
    "tasks": "Tools & consumables.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.3",
    "tasks": "Scaffolding.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.4",
    "tasks": "Material unloading and shifting to offloading area.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.5",
    "tasks": "Material distribution from offloading area.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.6",
    "tasks": "Temporary site facilities (Toilet, etc).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.7",
    "tasks": "Material handling equipment for unloading and offloading.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.8",
    "tasks": "Materials site storage.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.9",
    "tasks": "Removal of temporary site facilities upon completion.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.10",
    "tasks": "Cleaning of the site upon project completion.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.3",
    "tasks": "Testing and Commissioning",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.3.1",
    "tasks": "Mechanical acceptance.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.3.2",
    "tasks": "Testing and commissioning.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7",
    "tasks": "Other (Delivery, Production, etc)",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "7.1",
    "tasks": "Packing",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "7.2",
    "tasks": "Delivery crating FOB to job site.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.3",
    "tasks": "Attic stock.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.4",
    "tasks": "Road Access, crane operation area, or parking permits.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.5",
    "tasks": "Traffic diversion/control fees.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.6",
    "tasks": "Architectural responsibility pertaining to fire, sound, and insulation. (remains in architect’s scope of work).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.7",
    "tasks": "Independent inspections such as geotechnical conditions, concrete, reinforcing steel (re-bar), related materials, mortar, etc.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.8",
    "tasks": "Perimeter foaming.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.9",
    "tasks": "Performance mock-up.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.10",
    "tasks": "Smoke seal.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.11",
    "tasks": "Acoustic sealants.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.12",
    "tasks": "Costs associated with use of the material hoist and crane.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.13",
    "tasks": "Construction of or supply of spray racks, chambers, water supply or any other material for field testing.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.14",
    "tasks": "Final cleaning of panel, including removal of stickers/labels, and protective films.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.15",
    "tasks": "All hoarding permits and public protection.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.16",
    "tasks": "Supply and installation of any signage and provision to accommodate the same.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.17",
    "tasks": "Provisions for acoustic insulation and sound dampening materials, either floor-to-floor or room-to-room.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.18",
    "tasks": "Supply of exhaust boxes and vents. Connection of any mechanical components.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.19",
    "tasks": "Responsibility of garbage disposal from site, maintenance of container, and container available on site.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.20",
    "tasks": "Repair of damages made to products/structures by other sub-trades.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.21",
    "tasks": "Preparation of installation areas covered by grass, interlocking, etc.",
    "cladify": false,
    "client": true
  }
]

const supplyCladdingIl = [
  {
    "item no.": "1",
    "tasks": "PROJECT MANAGEMENT",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "1.1",
    "tasks": "Project planning, construction management on site and construction meeting and reporting.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "1.2",
    "tasks": "Progress reporting.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "1.3",
    "tasks": "General Coordination of the project with Client.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "1.4",
    "tasks": "Health and safety management.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "1.5",
    "tasks": "Coordination between Employer, subcontractors, and authorities.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "1.6",
    "tasks": "Construction site insurance.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "1.7",
    "tasks": "Construction signage (transportation, warnings).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "2",
    "tasks": "DOCUMENTATIONS",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "2.1",
    "tasks": "Safety Induction Documentation.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "2.2",
    "tasks": "Method Statement & Risk Assessment for Installation.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "2.3",
    "tasks": "HSE Compliance Documentation.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "2.4",
    "tasks": "Markup of IFC drawings for any changes to be incorporated into the as-built drawings.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "3",
    "tasks": "PERMITS",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "3.1",
    "tasks": "Relation and permitting with municipality regarding building permits.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "3.2",
    "tasks": "All local and federal government building permit charges.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "4",
    "tasks": "DESIGN",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "4.1",
    "tasks": "Engineering",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "4.1.1",
    "tasks": "Shop drawings, engineering - All engineering for panel systems, including calculations stamped by a professional engineer.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "4.1.2",
    "tasks": "Update of the Structural study provided by the client that the additional load capacity will not affect the structure.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "4.1.3",
    "tasks": "Temporary facilities layout (if needed).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5",
    "tasks": "PROCUREMENT",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "5.1",
    "tasks": "Modules",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "5.1.1",
    "tasks": "Modules.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.1.2",
    "tasks": "Fenced allocated storage area on site for modules.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2",
    "tasks": "Structure & Mechanical",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "5.2.1",
    "tasks": "Anchorage, mounting accessories, and fasteners.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2.2",
    "tasks": "Interlocking channels.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2.3",
    "tasks": "L-Bars.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.4",
    "tasks": "Thermal Breaks.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.5",
    "tasks": "Insulation: 2” Rockwool Cavityrock Exterior Insulation for Cavity Wall and Rainscreen Applications or equal product.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.6",
    "tasks": "AWB: Dorken DELTA-STRATUS SA Self-Adhered Water-Resistive Barrier & Air Barrier with High UV Resistance or equal product.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.7",
    "tasks": "Flashing at head and jamb of windows as required- 24-gauge single side prepainted galvanized steel cold bended sheets.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.8",
    "tasks": "Field applied caulking/sealant with backer rod between Cladify panels and panel joints only.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.9",
    "tasks": "Caulking and backer rod around adjacent materials, and panel return to window, doors, louvers and penetrations.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.10",
    "tasks": "HSE permanent protections.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.11",
    "tasks": "Window sill flashing.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.12",
    "tasks": "Thru-wall or counter flashings.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.13",
    "tasks": "Roofing membrane. Any cap flashing at interface with roofing and structure.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6",
    "tasks": "CONSTRUCTION",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.1",
    "tasks": "System Installation",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.1.1",
    "tasks": "Installation of modules including mechanical anchoring and mounting.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.2",
    "tasks": "Cutting and patching of slab edges.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.3",
    "tasks": "Spray or liquid applied air or air/vapour barrier.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.4",
    "tasks": "Insulation systems.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.5",
    "tasks": "Any type of air/vapour barrier tie-ins around any opening such as windows, doors, louvers and penetrations as this is the responsibility of the trade installing such item(s).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.6",
    "tasks": "Installation of wood backing or blocking.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.7",
    "tasks": "Installation of any exterior lighting, cameras, conduits, and all other electrical components.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.8",
    "tasks": "Any / all structural anchors and fasteners.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.9",
    "tasks": "Substrate framing, structural supports, structural steel and metal stud framing, structural steel studs, sheathing products (DensGlass, plywood, etc.), top parapet, top parapet flashing. System depth passing 8” will be considered as a structural component.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.10",
    "tasks": "Leveling the structure and existing walls.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.11",
    "tasks": "Supply or installation of windows or doors.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.12",
    "tasks": "Removal of any overhead obstacles (trees, electrical wiring, cables etc.), exterior lighting, cameras and others which could interfere with the installation of the system.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.13",
    "tasks": "Provisions and maintenance of work areas, storage areas with worksite access and security, and sufficient loading capacity at any time to allow for vehicle and equipment circulation for storage of materials, and removal of snow preventing the access during winter season.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.14",
    "tasks": "Supply or installation of miscellaneous metals such as support shelves, access ladders, railings, bollards and/or fencing, exterior or interior stairs.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.15",
    "tasks": "Provision of security of panels and other materials at the job site.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2",
    "tasks": "Other Works",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.2.1",
    "tasks": "PPE and safety harness.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.2",
    "tasks": "Tools & consumables.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.3",
    "tasks": "Scaffolding.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.4",
    "tasks": "Material unloading and shifting to offloading area.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.5",
    "tasks": "Material distribution from offloading area.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.6",
    "tasks": "Temporary site facilities (Toilet, etc).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.7",
    "tasks": "Material handling equipment for unloading and offloading.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.8",
    "tasks": "Materials site storage.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.9",
    "tasks": "Removal of temporary site facilities upon completion.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.10",
    "tasks": "Cleaning of the site upon project completion.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.3",
    "tasks": "Testing and Commissioning",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.3.1",
    "tasks": "Mechanical acceptance.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.3.2",
    "tasks": "Testing and commissioning.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7",
    "tasks": "Other (Delivery, Production, etc)",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "7.1",
    "tasks": "Packing",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "7.2",
    "tasks": "Delivery crating FOB to job site.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.3",
    "tasks": "Attic stock.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.4",
    "tasks": "Road Access, crane operation area, or parking permits.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.5",
    "tasks": "Traffic diversion/control fees.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.6",
    "tasks": "Architectural responsibility pertaining to fire, sound, and insulation. (remains in architect’s scope of work).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.7",
    "tasks": "Independent inspections such as geotechnical conditions, concrete, reinforcing steel (re-bar), related materials, mortar, etc.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.8",
    "tasks": "Perimeter foaming.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.9",
    "tasks": "Performance mock-up.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.10",
    "tasks": "Smoke seal.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.11",
    "tasks": "Acoustic sealants.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.12",
    "tasks": "Costs associated with use of the material hoist and crane.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.13",
    "tasks": "Construction of or supply of spray racks, chambers, water supply or any other material for field testing.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.14",
    "tasks": "Final cleaning of panel, including removal of stickers/labels, and protective films.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.15",
    "tasks": "All hoarding permits and public protection.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.16",
    "tasks": "Supply and installation of any signage and provision to accommodate the same.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.17",
    "tasks": "Provisions for acoustic insulation and sound dampening materials, either floor-to-floor or room-to-room.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.18",
    "tasks": "Supply of exhaust boxes and vents. Connection of any mechanical components.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.19",
    "tasks": "Responsibility of garbage disposal from site, maintenance of container, and container available on site.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.20",
    "tasks": "Repair of damages made to products/structures by other sub-trades.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.21",
    "tasks": "Preparation of installation areas covered by grass, interlocking, etc.",
    "cladify": false,
    "client": true
  }
]

const supplyCladdingIlMore = [
  {
    "item no.": "1",
    "tasks": "PROJECT MANAGEMENT",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "1.1",
    "tasks": "Project planning, construction management on site and construction meeting and reporting.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "1.2",
    "tasks": "Progress reporting.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "1.3",
    "tasks": "General Coordination of the project with Client.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "1.4",
    "tasks": "Health and safety management.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "1.5",
    "tasks": "Coordination between Employer, subcontractors, and authorities.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "1.6",
    "tasks": "Construction site insurance.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "1.7",
    "tasks": "Construction signage (transportation, warnings).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "2",
    "tasks": "DOCUMENTATIONS",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "2.1",
    "tasks": "Safety Induction Documentation.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "2.2",
    "tasks": "Method Statement & Risk Assessment for Installation.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "2.3",
    "tasks": "HSE Compliance Documentation.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "2.4",
    "tasks": "Markup of IFC drawings for any changes to be incorporated into the as-built drawings.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "3",
    "tasks": "PERMITS",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "3.1",
    "tasks": "Relation and permitting with municipality regarding building permits.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "3.2",
    "tasks": "All local and federal government building permit charges.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "4",
    "tasks": "DESIGN",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "4.1",
    "tasks": "Engineering",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "4.1.1",
    "tasks": "Shop drawings, engineering - All engineering for panel systems, including calculations stamped by a professional engineer.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "4.1.2",
    "tasks": "Update of the Structural study provided by the client that the additional load capacity will not affect the structure.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "4.1.3",
    "tasks": "Temporary facilities layout (if needed).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5",
    "tasks": "PROCUREMENT",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "5.1",
    "tasks": "Modules",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "5.1.1",
    "tasks": "Modules.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.1.2",
    "tasks": "Fenced allocated storage area on site for modules.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2",
    "tasks": "Structure & Mechanical",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "5.2.1",
    "tasks": "Anchorage, mounting accessories, and fasteners.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2.2",
    "tasks": "Interlocking channels.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2.3",
    "tasks": "L-Bars.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2.4",
    "tasks": "Thermal Breaks.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2.5",
    "tasks": "Insulation: 2” Rockwool Cavityrock Exterior Insulation for Cavity Wall and Rainscreen Applications or equal product.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.6",
    "tasks": "AWB: Dorken DELTA-STRATUS SA Self-Adhered Water-Resistive Barrier & Air Barrier with High UV Resistance or equal product.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.7",
    "tasks": "Flashing at head and jamb of windows as required- 24-gauge single side prepainted galvanized steel cold bended sheets.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.8",
    "tasks": "Field applied caulking/sealant with backer rod between Cladify panels and panel joints only.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.9",
    "tasks": "Caulking and backer rod around adjacent materials, and panel return to window, doors, louvers and penetrations.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.10",
    "tasks": "HSE permanent protections.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.11",
    "tasks": "Window sill flashing.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.12",
    "tasks": "Thru-wall or counter flashings.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.13",
    "tasks": "Roofing membrane. Any cap flashing at interface with roofing and structure.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6",
    "tasks": "CONSTRUCTION",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.1",
    "tasks": "System Installation",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.1.1",
    "tasks": "Installation of modules including mechanical anchoring and mounting.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.2",
    "tasks": "Cutting and patching of slab edges.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.3",
    "tasks": "Spray or liquid applied air or air/vapour barrier.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.4",
    "tasks": "Insulation systems.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.5",
    "tasks": "Any type of air/vapour barrier tie-ins around any opening such as windows, doors, louvers and penetrations as this is the responsibility of the trade installing such item(s).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.6",
    "tasks": "Installation of wood backing or blocking.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.7",
    "tasks": "Installation of any exterior lighting, cameras, conduits, and all other electrical components.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.8",
    "tasks": "Any / all structural anchors and fasteners.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.9",
    "tasks": "Substrate framing, structural supports, structural steel and metal stud framing, structural steel studs, sheathing products (DensGlass, plywood, etc.), top parapet, top parapet flashing. System depth passing 8” will be considered as a structural component.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.10",
    "tasks": "Leveling the structure and existing walls.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.11",
    "tasks": "Supply or installation of windows or doors.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.12",
    "tasks": "Removal of any overhead obstacles (trees, electrical wiring, cables etc.), exterior lighting, cameras and others which could interfere with the installation of the system.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.13",
    "tasks": "Provisions and maintenance of work areas, storage areas with worksite access and security, and sufficient loading capacity at any time to allow for vehicle and equipment circulation for storage of materials, and removal of snow preventing the access during winter season.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.14",
    "tasks": "Supply or installation of miscellaneous metals such as support shelves, access ladders, railings, bollards and/or fencing, exterior or interior stairs.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.15",
    "tasks": "Provision of security of panels and other materials at the job site.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2",
    "tasks": "Other Works",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.2.1",
    "tasks": "PPE and safety harness.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.2",
    "tasks": "Tools & consumables.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.3",
    "tasks": "Scaffolding.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.4",
    "tasks": "Material unloading and shifting to offloading area.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.5",
    "tasks": "Material distribution from offloading area.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.6",
    "tasks": "Temporary site facilities (Toilet, etc).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.7",
    "tasks": "Material handling equipment for unloading and offloading.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.8",
    "tasks": "Materials site storage.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.9",
    "tasks": "Removal of temporary site facilities upon completion.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.10",
    "tasks": "Cleaning of the site upon project completion.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.3",
    "tasks": "Testing and Commissioning",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.3.1",
    "tasks": "Mechanical acceptance.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.3.2",
    "tasks": "Testing and commissioning.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7",
    "tasks": "Other (Delivery, Production, etc)",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "7.1",
    "tasks": "Packing",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "7.2",
    "tasks": "Delivery crating FOB to job site.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.3",
    "tasks": "Attic stock.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.4",
    "tasks": "Road Access, crane operation area, or parking permits.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.5",
    "tasks": "Traffic diversion/control fees.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.6",
    "tasks": "Architectural responsibility pertaining to fire, sound, and insulation. (remains in architect’s scope of work).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.7",
    "tasks": "Independent inspections such as geotechnical conditions, concrete, reinforcing steel (re-bar), related materials, mortar, etc.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.8",
    "tasks": "Perimeter foaming.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.9",
    "tasks": "Performance mock-up.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.10",
    "tasks": "Smoke seal.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.11",
    "tasks": "Acoustic sealants.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.12",
    "tasks": "Costs associated with use of the material hoist and crane.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.13",
    "tasks": "Construction of or supply of spray racks, chambers, water supply or any other material for field testing.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.14",
    "tasks": "Final cleaning of panel, including removal of stickers/labels, and protective films.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.15",
    "tasks": "All hoarding permits and public protection.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.16",
    "tasks": "Supply and installation of any signage and provision to accommodate the same.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.17",
    "tasks": "Provisions for acoustic insulation and sound dampening materials, either floor-to-floor or room-to-room.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.18",
    "tasks": "Supply of exhaust boxes and vents. Connection of any mechanical components.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.19",
    "tasks": "Responsibility of garbage disposal from site, maintenance of container, and container available on site.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.20",
    "tasks": "Repair of damages made to products/structures by other sub-trades.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.21",
    "tasks": "Preparation of installation areas covered by grass, interlocking, etc.",
    "cladify": false,
    "client": true
  }
]

const supplyInstall = [
  {
    "item no.": "1",
    "tasks": "PROJECT MANAGEMENT",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "1.1",
    "tasks": "Project planning, construction management on site and construction meeting and reporting.",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "1.2",
    "tasks": "Progress reporting.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "1.3",
    "tasks": "General Coordination of the project with Client.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "1.4",
    "tasks": "Health and safety management.",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "1.5",
    "tasks": "Coordination between Employer, subcontractors, and authorities.",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "1.6",
    "tasks": "Construction site insurance.",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "1.7",
    "tasks": "Construction signage (transportation, warnings).",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "2",
    "tasks": "DOCUMENTATIONS",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "2.1",
    "tasks": "Safety Induction Documentation.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "2.2",
    "tasks": "Method Statement & Risk Assessment for Installation.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "2.3",
    "tasks": "HSE Compliance Documentation.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "2.4",
    "tasks": "Markup of IFC drawings for any changes to be incorporated into the as-built drawings.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "3",
    "tasks": "PERMITS",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "3.1",
    "tasks": "Relation and permitting with municipality regarding building permits.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "3.2",
    "tasks": "All local and federal government building permit charges.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "4",
    "tasks": "DESIGN",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "4.1",
    "tasks": "Engineering",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "4.1.1",
    "tasks": "Shop drawings, engineering - All engineering for panel systems, including calculations stamped by a professional engineer.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "4.1.2",
    "tasks": "Update of the Structural study provided by the client that the additional load capacity will not affect the structure.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "4.1.3",
    "tasks": "Temporary facilities layout (if needed).",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5",
    "tasks": "PROCUREMENT",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "5.1",
    "tasks": "Modules",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "5.1.1",
    "tasks": "Modules.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.1.2",
    "tasks": "Fenced allocated storage area on site for modules.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2",
    "tasks": "Structure & Mechanical",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "5.2.1",
    "tasks": "Anchorage, mounting accessories, and fasteners.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2.2",
    "tasks": "Interlocking channels.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2.3",
    "tasks": "L-Bars.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2.4",
    "tasks": "Thermal Breaks.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2.5",
    "tasks": "Insulation: 2” Rockwool Cavityrock Exterior Insulation for Cavity Wall and Rainscreen Applications or equal product.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2.6",
    "tasks": "AWB: Dorken DELTA-STRATUS SA Self-Adhered Water-Resistive Barrier & Air Barrier with High UV Resistance or equal product.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2.7",
    "tasks": "Flashing at head and jamb of windows as required- 24-gauge single side prepainted galvanized steel cold bended sheets.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2.8",
    "tasks": "Field applied caulking/sealant with backer rod between Cladify panels and panel joints only.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2.9",
    "tasks": "Caulking and backer rod around adjacent materials, and panel return to window, doors, louvers and penetrations.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.10",
    "tasks": "HSE permanent protections.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.11",
    "tasks": "Window sill flashing.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.12",
    "tasks": "Thru-wall or counter flashings.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.13",
    "tasks": "Roofing membrane. Any cap flashing at interface with roofing and structure.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6",
    "tasks": "CONSTRUCTION",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.1",
    "tasks": "System Installation",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.1.1",
    "tasks": "Installation of modules including mechanical anchoring and mounting.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.1.2",
    "tasks": "Cutting and patching of slab edges.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.3",
    "tasks": "Spray or liquid applied air or air/vapour barrier.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.1.4",
    "tasks": "Insulation systems.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.1.5",
    "tasks": "Any type of air/vapour barrier tie-ins around any opening such as windows, doors, louvers and penetrations as this is the responsibility of the trade installing such item(s).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.6",
    "tasks": "Installation of wood backing or blocking.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.7",
    "tasks": "Installation of any exterior lighting, cameras, conduits, and all other electrical components.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.8",
    "tasks": "Any / all structural anchors and fasteners.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.1.9",
    "tasks": "Substrate framing, structural supports, structural steel and metal stud framing, structural steel studs, sheathing products (DensGlass, plywood, etc.), top parapet, top parapet flashing. System depth passing 8” will be considered as a structural component.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.10",
    "tasks": "Leveling the structure and existing walls.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.11",
    "tasks": "Supply or installation of windows or doors.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.12",
    "tasks": "Removal of any overhead obstacles (trees, electrical wiring, cables etc.), exterior lighting, cameras and others which could interfere with the installation of the system.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.13",
    "tasks": "Provisions and maintenance of work areas, storage areas with worksite access and security, and sufficient loading capacity at any time to allow for vehicle and equipment circulation for storage of materials, and removal of snow preventing the access during winter season.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.14",
    "tasks": "Supply or installation of miscellaneous metals such as support shelves, access ladders, railings, bollards and/or fencing, exterior or interior stairs.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.15",
    "tasks": "Provision of security of panels and other materials at the job site.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2",
    "tasks": "Other Works",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.2.1",
    "tasks": "PPE and safety harness.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.2.2",
    "tasks": "Tools & consumables.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.2.3",
    "tasks": "Scaffolding.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.2.4",
    "tasks": "Material unloading and shifting to offloading area.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.2.5",
    "tasks": "Material distribution from offloading area.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.2.6",
    "tasks": "Temporary site facilities (Toilet, etc).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.7",
    "tasks": "Material handling equipment for unloading and offloading.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.2.8",
    "tasks": "Materials site storage.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.2.9",
    "tasks": "Removal of temporary site facilities upon completion.",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "6.2.10",
    "tasks": "Cleaning of the site upon project completion.",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "6.3",
    "tasks": "Testing and Commissioning",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.3.1",
    "tasks": "Mechanical acceptance.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.3.2",
    "tasks": "Testing and commissioning.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "7",
    "tasks": "Other (Delivery, Production, etc)",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "7.1",
    "tasks": "Packing",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "7.2",
    "tasks": "Delivery crating FOB to job site.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "7.3",
    "tasks": "Attic stock.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.4",
    "tasks": "Road Access, crane operation area, or parking permits.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.5",
    "tasks": "Traffic diversion/control fees.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.6",
    "tasks": "Architectural responsibility pertaining to fire, sound, and insulation. (remains in architect’s scope of work).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.7",
    "tasks": "Independent inspections such as geotechnical conditions, concrete, reinforcing steel (re-bar), related materials, mortar, etc.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.8",
    "tasks": "Perimeter foaming.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.9",
    "tasks": "Performance mock-up.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.10",
    "tasks": "Smoke seal.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "7.11",
    "tasks": "Acoustic sealants.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.12",
    "tasks": "Costs associated with use of the material hoist and crane.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.13",
    "tasks": "Construction of or supply of spray racks, chambers, water supply or any other material for field testing.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.14",
    "tasks": "Final cleaning of panel, including removal of stickers/labels, and protective films.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.15",
    "tasks": "All hoarding permits and public protection.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.16",
    "tasks": "Supply and installation of any signage and provision to accommodate the same.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.17",
    "tasks": "Provisions for acoustic insulation and sound dampening materials, either floor-to-floor or room-to-room.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.18",
    "tasks": "Supply of exhaust boxes and vents. Connection of any mechanical components.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.19",
    "tasks": "Responsibility of garbage disposal from site, maintenance of container, and container available on site.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.20",
    "tasks": "Repair of damages made to products/structures by other sub-trades.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.21",
    "tasks": "Preparation of installation areas covered by grass, interlocking, etc.",
    "cladify": false,
    "client": true
  }
]

const supplyInstallCladicast = [
  {
    "item no.": "1",
    "tasks": "PROJECT MANAGEMENT",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "1.1",
    "tasks": "Project planning, construction management on site and construction meeting and reporting.",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "1.2",
    "tasks": "Progress reporting.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "1.3",
    "tasks": "General Coordination of the project with Client.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "1.4",
    "tasks": "Health and safety management.",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "1.5",
    "tasks": "Coordination between Employer, subcontractors, and authorities.",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "1.6",
    "tasks": "Construction site insurance.",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "1.7",
    "tasks": "Construction signage (transportation, warnings).",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "2",
    "tasks": "DOCUMENTATIONS",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "2.1",
    "tasks": "Safety Induction Documentation.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "2.2",
    "tasks": "Method Statement & Risk Assessment for Installation.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "2.3",
    "tasks": "HSE Compliance Documentation.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "2.4",
    "tasks": "Markup of IFC drawings for any changes to be incorporated into the as-built drawings.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "3",
    "tasks": "PERMITS",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "3.1",
    "tasks": "Relation and permitting with municipality regarding building permits.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "3.2",
    "tasks": "All local and federal government building permit charges.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "4",
    "tasks": "DESIGN",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "4.1",
    "tasks": "Engineering",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "4.1.1",
    "tasks": "Shop drawings, engineering - All engineering for panel systems, including calculations stamped by a professional engineer.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "4.1.2",
    "tasks": "Update of the Structural study provided by the client that the additional load capacity will not affect the structure.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "4.1.3",
    "tasks": "Temporary facilities layout (if needed).",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5",
    "tasks": "PROCUREMENT",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "5.1",
    "tasks": "Modules",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "5.1.1",
    "tasks": "Modules.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.1.2",
    "tasks": "Fenced allocated storage area on site for modules.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2",
    "tasks": "Structure & Mechanical",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "5.2.1",
    "tasks": "Anchorage, mounting accessories, and fasteners.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2.2",
    "tasks": "Interlocking channels.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.3",
    "tasks": "L-Bars.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.4",
    "tasks": "Thermal Breaks.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.5",
    "tasks": "Insulation: 2” Rockwool Cavityrock Exterior Insulation for Cavity Wall and Rainscreen Applications or equal product.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.6",
    "tasks": "AWB: Dorken DELTA-STRATUS SA Self-Adhered Water-Resistive Barrier & Air Barrier with High UV Resistance or equal product.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.7",
    "tasks": "Flashing at head and jamb of windows as required- 24-gauge single side prepainted galvanized steel cold bended sheets.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.8",
    "tasks": "Field applied caulking/sealant with backer rod between Cladify panels and panel joints only.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.9",
    "tasks": "Caulking and backer rod around adjacent materials, and panel return to window, doors, louvers and penetrations.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.10",
    "tasks": "HSE permanent protections.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.11",
    "tasks": "Window sill flashing.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.12",
    "tasks": "Thru-wall or counter flashings.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.13",
    "tasks": "Roofing membrane. Any cap flashing at interface with roofing and structure.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6",
    "tasks": "CONSTRUCTION",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.1",
    "tasks": "System Installation",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.1.1",
    "tasks": "Installation of modules including mechanical anchoring and mounting.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.1.2",
    "tasks": "Cutting and patching of slab edges.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.3",
    "tasks": "Spray or liquid applied air or air/vapour barrier.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.4",
    "tasks": "Insulation systems.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.5",
    "tasks": "Any type of air/vapour barrier tie-ins around any opening such as windows, doors, louvers and penetrations as this is the responsibility of the trade installing such item(s).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.6",
    "tasks": "Installation of wood backing or blocking.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.7",
    "tasks": "Installation of any exterior lighting, cameras, conduits, and all other electrical components.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.8",
    "tasks": "Any / all structural anchors and fasteners.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.1.9",
    "tasks": "Substrate framing, structural supports, structural steel and metal stud framing, structural steel studs, sheathing products (DensGlass, plywood, etc.), top parapet, top parapet flashing. System depth passing 8” will be considered as a structural component.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.10",
    "tasks": "Leveling the structure and existing walls.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.11",
    "tasks": "Supply or installation of windows or doors.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.12",
    "tasks": "Removal of any overhead obstacles (trees, electrical wiring, cables etc.), exterior lighting, cameras and others which could interfere with the installation of the system.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.13",
    "tasks": "Provisions and maintenance of work areas, storage areas with worksite access and security, and sufficient loading capacity at any time to allow for vehicle and equipment circulation for storage of materials, and removal of snow preventing the access during winter season.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.14",
    "tasks": "Supply or installation of miscellaneous metals such as support shelves, access ladders, railings, bollards and/or fencing, exterior or interior stairs.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.15",
    "tasks": "Provision of security of panels and other materials at the job site.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2",
    "tasks": "Other Works",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.2.1",
    "tasks": "PPE and safety harness.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.2.2",
    "tasks": "Tools & consumables.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.2.3",
    "tasks": "Scaffolding.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.2.4",
    "tasks": "Material unloading and shifting to offloading area.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.2.5",
    "tasks": "Material distribution from offloading area.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.2.6",
    "tasks": "Temporary site facilities (Toilet, etc).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.7",
    "tasks": "Material handling equipment for unloading and offloading.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.2.8",
    "tasks": "Materials site storage.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.2.9",
    "tasks": "Removal of temporary site facilities upon completion.",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "6.2.10",
    "tasks": "Cleaning of the site upon project completion.",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "6.3",
    "tasks": "Testing and Commissioning",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.3.1",
    "tasks": "Mechanical acceptance.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.3.2",
    "tasks": "Testing and commissioning.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "7",
    "tasks": "Other (Delivery, Production, etc)",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "7.1",
    "tasks": "Packing",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "7.2",
    "tasks": "Delivery crating FOB to job site.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "7.3",
    "tasks": "Attic stock.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.4",
    "tasks": "Road Access, crane operation area, or parking permits.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.5",
    "tasks": "Traffic diversion/control fees.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.6",
    "tasks": "Architectural responsibility pertaining to fire, sound, and insulation. (remains in architect’s scope of work).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.7",
    "tasks": "Independent inspections such as geotechnical conditions, concrete, reinforcing steel (re-bar), related materials, mortar, etc.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.8",
    "tasks": "Perimeter foaming.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.9",
    "tasks": "Performance mock-up.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.10",
    "tasks": "Smoke seal.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.11",
    "tasks": "Acoustic sealants.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.12",
    "tasks": "Costs associated with use of the material hoist and crane.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.13",
    "tasks": "Construction of or supply of spray racks, chambers, water supply or any other material for field testing.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.14",
    "tasks": "Final cleaning of panel, including removal of stickers/labels, and protective films.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.15",
    "tasks": "All hoarding permits and public protection.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.16",
    "tasks": "Supply and installation of any signage and provision to accommodate the same.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.17",
    "tasks": "Provisions for acoustic insulation and sound dampening materials, either floor-to-floor or room-to-room.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.18",
    "tasks": "Supply of exhaust boxes and vents. Connection of any mechanical components.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.19",
    "tasks": "Responsibility of garbage disposal from site, maintenance of container, and container available on site.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.20",
    "tasks": "Repair of damages made to products/structures by other sub-trades.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.21",
    "tasks": "Preparation of installation areas covered by grass, interlocking, etc.",
    "cladify": false,
    "client": true
  }
]

const supplyInstallCladifabLimited = [
  {
    "item no.": "1",
    "tasks": "PROJECT MANAGEMENT",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "1.1",
    "tasks": "Project planning, construction management on site and construction meeting and reporting.",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "1.2",
    "tasks": "Progress reporting.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "1.3",
    "tasks": "General Coordination of the project with Client.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "1.4",
    "tasks": "Health and safety management.",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "1.5",
    "tasks": "Coordination between Employer, subcontractors, and authorities.",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "1.6",
    "tasks": "Construction site insurance.",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "1.7",
    "tasks": "Construction signage (transportation, warnings).",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "2",
    "tasks": "DOCUMENTATIONS",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "2.1",
    "tasks": "Safety Induction Documentation.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "2.2",
    "tasks": "Method Statement & Risk Assessment for Installation.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "2.3",
    "tasks": "HSE Compliance Documentation.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "2.4",
    "tasks": "Markup of IFC drawings for any changes to be incorporated into the as-built drawings.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "3",
    "tasks": "PERMITS",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "3.1",
    "tasks": "Relation and permitting with municipality regarding building permits.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "3.2",
    "tasks": "All local and federal government building permit charges.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "4",
    "tasks": "DESIGN",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "4.1",
    "tasks": "Engineering",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "4.1.1",
    "tasks": "Shop drawings, engineering - All engineering for panel systems, including calculations stamped by a professional engineer.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "4.1.2",
    "tasks": "Update of the Structural study provided by the client that the additional load capacity will not affect the structure.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "4.1.3",
    "tasks": "Temporary facilities layout (if needed).",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5",
    "tasks": "PROCUREMENT",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "5.1",
    "tasks": "Modules",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "5.1.1",
    "tasks": "Modules.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.1.2",
    "tasks": "Fenced allocated storage area on site for modules.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2",
    "tasks": "Structure & Mechanical",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "5.2.1",
    "tasks": "Anchorage, mounting accessories, and fasteners.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2.2",
    "tasks": "Interlocking channels.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2.3",
    "tasks": "L-Bars.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2.4",
    "tasks": "Thermal Breaks.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2.5",
    "tasks": "Insulation: 2” Rockwool Cavityrock Exterior Insulation for Cavity Wall and Rainscreen Applications or equal product.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2.6",
    "tasks": "AWB: Dorken DELTA-STRATUS SA Self-Adhered Water-Resistive Barrier & Air Barrier with High UV Resistance or equal product.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2.7",
    "tasks": "Flashing at head and jamb of windows as required- 24-gauge single side prepainted galvanized steel cold bended sheets.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "5.2.8",
    "tasks": "Field applied caulking/sealant with backer rod between Cladify panels and panel joints only.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.9",
    "tasks": "Caulking and backer rod around adjacent materials, and panel return to window, doors, louvers and penetrations.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.10",
    "tasks": "HSE permanent protections.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.11",
    "tasks": "Window sill flashing.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.12",
    "tasks": "Thru-wall or counter flashings.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "5.2.13",
    "tasks": "Roofing membrane. Any cap flashing at interface with roofing and structure.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6",
    "tasks": "CONSTRUCTION",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.1",
    "tasks": "System Installation",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.1.1",
    "tasks": "Installation of modules including mechanical anchoring and mounting.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.1.2",
    "tasks": "Cutting and patching of slab edges.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.3",
    "tasks": "Spray or liquid applied air or air/vapour barrier.",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "6.1.4",
    "tasks": "Insulation systems.",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "6.1.5",
    "tasks": "Any type of air/vapour barrier tie-ins around any opening such as windows, doors, louvers and penetrations as this is the responsibility of the trade installing such item(s).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.6",
    "tasks": "Installation of wood backing or blocking.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.7",
    "tasks": "Installation of any exterior lighting, cameras, conduits, and all other electrical components.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.8",
    "tasks": "Any / all structural anchors and fasteners.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.1.9",
    "tasks": "Substrate framing, structural supports, structural steel and metal stud framing, structural steel studs, sheathing products (DensGlass, plywood, etc.), top parapet, top parapet flashing. System depth passing 8” will be considered as a structural component.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.10",
    "tasks": "Leveling the structure and existing walls.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.11",
    "tasks": "Supply or installation of windows or doors.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.12",
    "tasks": "Removal of any overhead obstacles (trees, electrical wiring, cables etc.), exterior lighting, cameras and others which could interfere with the installation of the system.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.13",
    "tasks": "Provisions and maintenance of work areas, storage areas with worksite access and security, and sufficient loading capacity at any time to allow for vehicle and equipment circulation for storage of materials, and removal of snow preventing the access during winter season.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.14",
    "tasks": "Supply or installation of miscellaneous metals such as support shelves, access ladders, railings, bollards and/or fencing, exterior or interior stairs.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.1.15",
    "tasks": "Provision of security of panels and other materials at the job site.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2",
    "tasks": "Other Works",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.2.1",
    "tasks": "PPE and safety harness.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.2.2",
    "tasks": "Tools & consumables.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.2.3",
    "tasks": "Scaffolding.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.2.4",
    "tasks": "Material unloading and shifting to offloading area.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.2.5",
    "tasks": "Material distribution from offloading area.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.2.6",
    "tasks": "Temporary site facilities (Toilet, etc).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "6.2.7",
    "tasks": "Material handling equipment for unloading and offloading.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.2.8",
    "tasks": "Materials site storage.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.2.9",
    "tasks": "Removal of temporary site facilities upon completion.",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "6.2.10",
    "tasks": "Cleaning of the site upon project completion.",
    "cladify": true,
    "client": true
  },
  {
    "item no.": "6.3",
    "tasks": "Testing and Commissioning",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "6.3.1",
    "tasks": "Mechanical acceptance.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "6.3.2",
    "tasks": "Testing and commissioning.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "7",
    "tasks": "Other (Delivery, Production, etc)",
    "cladify": "",
    "client": ""
  },
  {
    "item no.": "7.1",
    "tasks": "Packing",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "7.2",
    "tasks": "Delivery crating FOB to job site.",
    "cladify": true,
    "client": false
  },
  {
    "item no.": "7.3",
    "tasks": "Attic stock.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.4",
    "tasks": "Road Access, crane operation area, or parking permits.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.5",
    "tasks": "Traffic diversion/control fees.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.6",
    "tasks": "Architectural responsibility pertaining to fire, sound, and insulation. (remains in architect’s scope of work).",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.7",
    "tasks": "Independent inspections such as geotechnical conditions, concrete, reinforcing steel (re-bar), related materials, mortar, etc.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.8",
    "tasks": "Perimeter foaming.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.9",
    "tasks": "Performance mock-up.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.10",
    "tasks": "Smoke seal.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.11",
    "tasks": "Acoustic sealants.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.12",
    "tasks": "Costs associated with use of the material hoist and crane.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.13",
    "tasks": "Construction of or supply of spray racks, chambers, water supply or any other material for field testing.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.14",
    "tasks": "Final cleaning of panel, including removal of stickers/labels, and protective films.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.15",
    "tasks": "All hoarding permits and public protection.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.16",
    "tasks": "Supply and installation of any signage and provision to accommodate the same.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.17",
    "tasks": "Provisions for acoustic insulation and sound dampening materials, either floor-to-floor or room-to-room.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.18",
    "tasks": "Supply of exhaust boxes and vents. Connection of any mechanical components.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.19",
    "tasks": "Responsibility of garbage disposal from site, maintenance of container, and container available on site.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.20",
    "tasks": "Repair of damages made to products/structures by other sub-trades.",
    "cladify": false,
    "client": true
  },
  {
    "item no.": "7.21",
    "tasks": "Preparation of installation areas covered by grass, interlocking, etc.",
    "cladify": false,
    "client": true
  }
]

export const inclusionsAndExclusions = {
  'dpa_turnkey': dpaTurnkey,
  'mpa_turnkey': mpaTurnkey,
  'panels_only': panelsOnly,
  'panels_electrical': panelsElectrical,
  'panels_electrical_cladding': panelsElectricalCladding,
  'cladicast': cladicast,
  'supply_only': supplyOnly,
  'supply_cladding_il': supplyCladdingIl,
  'supply_cladding_il_more': supplyCladdingIlMore,
  'supply_install': supplyInstall,
  'supply_install_cladicast': supplyInstallCladicast,
  'supply_install_cladifab_limited': supplyInstallCladifabLimited
}